export default {
    "generalErrorMessage": {
        "fieldIsRequired": "El campo es requerido",
        "field_required": "Este campo es requerido",
        "something_went_wrong": "Algo salió mal"
    },
    "authErrorMessage": {
        "emailError": "The email field must be a valid email",
        "passwordValid": "The password field must be at least 8 characters",
        "validPassRegex": "Passwords must be at least 8 characters long, and contain at least 1 alphabet,1 uppercase, 1 numeric, and 1 special character",
        "confirmPasswordValid": "The confirm password confirmation does not match",
        "validCharactersfirst": "The first name field may only contain alphabetic characters as well as spaces",
        "validCharacterslast": "The last name field may only contain alphabetic characters as well as spaces",
        "minMust": "must be at least 3 characters",
        "must_be_a_valid_email": "Must be a valid email",
        "currentPassword": "Las contraseñas actuales deben tener al menos 8 caracteres y contener al menos 1 alfabeto, 1 mayúscula, 1 numérico y 1 carácter especial",
        "newPassword": "Las nuevas contraseñas deben tener al menos 8 caracteres y contener al menos 1 alfabeto, 1 mayúscula, 1 numérico y 1 carácter especial",
        "currentPasswordValid": "El campo de contraseña actual debe tener al menos 8 caracteres.",
        "newPasswordValid": "El campo de la nueva contraseña debe tener al menos 8 caracteres.",
        "please_wait_before_resending_email": "Por favor, revise su correo electrónico. Si no lo ha recibido, puede reenviar el correo electrónico de verificación después de 1 minuto."
    },
    "companyErrorMessage": {
        "phoneNumberValid": "El campo del número de teléfono debe tener al menos 10 caracteres",
        "Something_went_wrong_Please_contact_to_admin": "Algo salió mal. Por favor, contacte al administrador"
    },
    "errorPage": {
        "project_name": "Nombre del proyecto",
        "project_key": "Clave del proyecto",
        "project_category": "Categoría del proyecto",
        "team_name": "Nombre del equipo",
        "The": "El",
        "field_must_be_a_valid": "el campo debe ser un válido",
        "email": "correo electrónico",
        "password": "Contraseña",
        "first_name": "primer nombre",
        "last_name": "apellido",
        "company_name": "nombre de la empresa",
        "file_extension": "extensión de archivo",
        "milestone_status": "estado del hito",
        "name": "nombre",
        "phone_number": "número de teléfono",
        "field_must_be_at_least": "el campo debe tener al menos",
        "number": "número",
        "characters": "caracteres",
        "digits": "dígitos",
        "priority_name": "nombre de la prioridad",
        "firstName": "primer nombre",
        "lastName": "apellido",
        "phoneNumber": "número de teléfono",
        "amount": "cantidad",
        "phone": "teléfono",
        "country": "país",
        "state": "estado",
        "city": "ciudad",
        "templatename": "nombre de la plantilla",
        "description": "descripción",
        "Template_name_is_required": "Se requiere el nombre de la plantilla",
        "This_template_name_is_required.": "Se requiere el nombre de la plantilla.",
        "status": "estado",
        "zipcode": "código postal",
        "address2": "dirección2",
        "address1": "dirección1",
        "The_confirm_password_field_is_required": "El campo de confirmación de contraseña es requerido",
        "The_confirm_password_confirmation_does_not_match": "La confirmación de la contraseña no coincide",
        "terms_and_condition": "términos y condiciones",
        "category_name": "nombre de la categoría",
        "channel_name": "nombre del canal",
        "amount_per_hours": "cantidad por hora",
        "refundamount": "cantidad de reembolso",
        "please_select_template": "Por favor, seleccione una plantilla",
        "template_name_already_exists": "El nombre de la plantilla ya existe",
        "select_a_date": "Seleccione una fecha",
        "must_be_less_than": "debe ser menos que",
        "project_duedate": "Fecha de vencimiento del proyecto",
        "project_lead_assignee": "Responsable del proyecto",
        "current_password": "Contraseña actual",
        "new_password": "Nueva contraseña",
        "confirm_password": "Confirmar Contraseña",
        "This_template_name_is_already_exists": "Este nombre de plantilla ya existe.",
        "card_name": "nombre de la tarjeta",
        "topic": "tema",
        "target_audience": "audiencia objetivo",
        "keywords": "palabras clave",
        "content_purpose": "propósito del contenido",
        "product/service": "producto/servicio",
        "campaign_goals": "objetivos de campaña",
        "value_proposition": "propuesta de valor",
        "objectives": "objetivos",
        "key_message": "mensaje clave",
        "problem": "problema",
        "context": "contexto",
        "constraints": "restricciones",
        "main_keyword": "palabra clave principal",
        "secondary_keywords": "palabras clave secundarias",
        "content_goal": "objetivo del contenido",
        "keyword_list": "lista de palabras clave",
        "questions": "preguntas",
        "product_description": "descripción del producto",
        "feedback_data": "datos de retroalimentación",
        "survey_questions": "preguntas de encuesta",
        "project": "proyecto",
        "progress_made": "progreso realizado",
        "next_steps": "próximos pasos",
        "key_features": "características clave",
        "client_type": "tipo de cliente",
        "challenges": "desafíos",
        "results": "resultados",
        "event_type": "tipo de evento",
        "cta": "llamada a la acción",
        "campaign_objectives": "objetivos de campaña",
        "survey_objectives": "objetivos de encuesta",
        "column_one_name": "nombre de la primera columna",
        "column_two_name": "nombre de la segunda columna",
        "column_one_data": "datos de la primera columna",
        "column_two_data": "datos de la segunda columna",
        "customer_name": "nombre del cliente",
        "email_purpose": "propósito del correo electrónico",
        "talking_points": "puntos de conversación",
        "product_name": "nombre del producto",
        "about_the_product": "acerca del producto",
        "core_problem_it_solves": "problema central que resuelve",
        "what_makes_it_different": "qué lo hace diferente",
        "the_product_is": "el producto es",
        "core_differentiators": "diferenciadores clave",
        "product/service_benefits": "beneficios del producto/servicio",
        "call_notes": "notas de la llamada",
        "call_transcript": "transcripción de la llamada",
        "target_company": "empresa objetivo",
        "use_case": "caso de uso",
        "customer_challenges": "desafíos del cliente",
        "territories": "territorios",
        "target_industries": "industrias objetivo",
        "sales_goals": "objetivos de ventas",
        "sales_strategies": "estrategias de ventas",
        "transcript": "transcripción",
        "pain_points": "puntos de dolor",
        "company_type": "tipo de empresa",
        "sales_cycle_stages": "etapas del ciclo de ventas",
        "sales_methodologies": "metodologías de ventas",
        "key_skills": "habilidades clave",
        "training_formats": "formatos de capacitación",
        "participants": "participantes",
        "target_industry": "industria objetivo",
        "value_statement": "declaración de valor",
        "meeting_type": "tipo de reunión",
        "your_talking_points": "tus puntos de conversación",
        "goal": "objetivo",
        "reasons_for_canceling": "razones para cancelar",
        "incentive": "incentivo",
        "unique_selling_points": "puntos de venta únicos",
        "desired_format": "formato deseado",
        "topics": "temas",
        "content": "contenido",
        "stakeholders": "partes interesadas",
        "sales_notes": "notas de ventas",
        "customer_goals": "objetivos del cliente",
        "teams_impacted": "equipos impactados",
        "requirements": "requisitos",
        "goals_met": "objetivos cumplidos",
        "project_stakeholders": "partes interesadas del proyecto",
        "opportunities": "oportunidades",
        "risks": "riesgos",
        "customer_message": "mensaje del cliente",
        "date_range": "rango de fechas",
        "project_notes": "notas del proyecto",
        "project_description": "descripción del proyecto",
        "name_of_project": "nombre del proyecto",
        "date_ranges": "rangos de fechas",
        "requestor": "solicitante",
        "requests": "solicitudes",
        "reason_for_the_change": "razón del cambio",
        "expected_impact_of_the_change": "impacto esperado del cambio",
        "project_goals": "objetivos del proyecto",
        "participant_names": "nombres de participantes",
        "meeting_time": "hora de la reunión",
        "timeline": "cronograma",
        "deliverables": "entregables",
        "project_goal": "objetivo del proyecto",
        "project_scope": "alcance del proyecto",
        "main_task": "tarea principal",
        "new_format": "nuevo formato",
        "original_text": "texto original",
        "stakeholder_titles": "títulos de las partes interesadas",
        "article_title": "título del artículo",
        "focus_keywords": "palabras clave de enfoque",
        "title_of_the_blog_text": "título del texto del blog",
        "blog_topic": "tema del blog",
        "section_title": "título de sección",
        "section_content": "contenido de sección",
        "section": "sección",
        "title": "título",
        "title(faq_question)": "título(pregunta FAQ)",
        "issue_description": "descripción del problema",
        "code_section": "sección de código",
        "concept": "concepto",
        "version": "versión",
        "changes": "cambios",
        "job_title": "título del trabajo",
        "your_name": "tu nombre",
        "your_skills": "tus habilidades",
        "math_question": "pregunta de matemáticas",
        "question": "pregunta",
        "thesis_topic": "tema de tesis",
        "text_to_proofread": "texto a corregir",
        "text_to_rephrase": "texto a reformular",
        "text_to_improve": "texto a mejorar",
        "job_description": "descripción del trabajo",
        "your_title": "tu título",
        "your_summary": "tu resumen",
        "pain": "dolor",
        "agitation": "agitación",
        "solution": "solución",
        "post_content": "contenido del post",
        "product_or_service": "producto o servicio",
        "unique_selling_proposition": "propuesta de venta única",
        "audiences_objectives": "objetivos de la audiencia",
        "email_to_reply_to": "campo de correo de respuesta",
        "sales_teams_roles": "roles del equipo de ventas"
    },
    "Auth": {
        "email": "Correo Electrónico",
        "password": "Contraseña",
        "firstName": "Primer Nombre",
        "lastName": "Apellido",
        "phoneNumber": "Número de Teléfono",
        "login_descriptioon": "Mira lo que está pasando con tu negocio",
        "login_statement": "Iniciar sesión en tu cuenta",
        "email_id": "ID de Correo Electrónico",
        "Password": "Contraseña",
        "Conform_pass": "Confirmar Contraseña",
        "RememberMeL": "Recuérdame",
        "Remember_password": "Recordar contraseña",
        "Forgot_Password": "Olvidé la contraseña",
        "loading": "Cargando",
        "loging": "Iniciar sesión",
        "Register": "Registrarse",
        "NotR": "¿Aún no te has registrado?",
        "createAcc": "Crear una cuenta",
        "alredyacc": "¿Ya tienes una cuenta?",
        "ResendEmail": "Reenviar correo electrónico",
        "pleasecheck": "Por favor revisa tu correo electrónico. Si no lo has recibido o lo has perdido, haz clic abajo para reenviar el correo.",
        "backlogin": "Volver a Iniciar sesión",
        "Welcome_Msg": "Bienvenido a BRAND_NAME",
        "Welcome_Description": "Obtén acceso a funciones exclusivas creando una cuenta",
        "agree": "Acepto los",
        "tearm": "Términos de servicio",
        "and": "y",
        "Privacy_Policy": "Política de privacidad",
        "forgatepasswordmsg": "Ingresa el correo electrónico asociado a tu cuenta y enviaremos un correo con instrucciones para restablecer tu contraseña.",
        "ltitle": "Trabaja en grandes ideas, sin la carga de trabajo innecesaria.",
        "time_format": "Formato de hora",
        "timezone": "Zona horaria",
        "selectLanguage": "Seleccionar idioma",
        "check_credentials": "Por favor, revisa tus credenciales.",
        "check_smtp_credentials": "Por favor, revisa tus credenciales SMTP.",
        "smtp_successfully_verified": "Tu SMTP ha sido verificado con éxito.",
        "verification_code_invalid": "Tu código de verificación es inválido.",
        "verification_code_invalid_check_code": "Tu código de verificación es inválido. Por favor revisa tu código.",
        "verification_mail_sent": "El correo de verificación ha sido enviado exitosamente. Por favor revisa tu bandeja de entrada.",
        "no_account_found_for_email": "No se encontró una cuenta para el correo electrónico proporcionado.",
        "verify_email_and_try_again": "Verifica tu correo electrónico e intenta nuevamente.",
        "confirm_password": "Confirmar Contraseña",
        "enter_new_password": "Por favor ingresa tu nueva contraseña",
        "link_expired_resend_email": "Tu enlace ha expirado.",
        "reset_password": "Restablecer Contraseña",
        "resend_verification_email": "Por favor haz clic en el botón para reenviar el correo de verificación",
        "link_expired": "Este enlace ha expirado",
        "too_many_request": "Ha enviado demasiadas solicitudes en un período de tiempo determinado. Espere y vuelva a intentarlo más tarde.",
        "previous_wasnot_valid": "Su contraseña anterior no era válida. Por favor, verifíquelo e inténtelo de nuevo.",
        "password_wasnot_valid": "Su nueva contraseña no era válida. Por favor, inténtelo de nuevo.",
        "set_new_password": "Establecer nueva contraseña",
        "verification_link_expired": "Este enlace de verificación ha expirado.",
        "verification_link_expired_message": "Por favor, revise su bandeja de entrada para el último correo electrónico de verificación. Si no lo ha recibido, intente iniciar sesión nuevamente para solicitar uno nuevo.",
        "oAuthGoogleBtnText": "Continuar con Google"
    },
    "Home": {
        "unlock": "Desbloquear",
        "lock": "Bloquear",
        "dashboardLockSuccess": "Panel bloqueado con éxito",
        "dashboardUnlockSuccess": "Panel desbloqueado con éxito",
        "Home": "Inicio",
        "My_Work": "Mi Trabajo",
        "Done": "Hecho",
        "To_Do": "Por Hacer",
        "no_task_found": "No se encontró ninguna tarea",
        "Confirm": "Confirmar",
        "tourclose": "¿Estás seguro de que deseas cerrar este recorrido? Si confirmas, no podrás acceder a esta guía nuevamente.",
        "Queue_List": "Lista de Cola",
        "AddtoQueue": "Agregar a la Cola",
        "noquelist": "No se encontró ninguna lista de cola",
        "Due_Date": "Fecha de Vencimiento",
        "createQueueTitle": "Crear Cola",
        "Today": "Hoy",
        "Calendar": "Calendario",
        "Hide": "Ocultar",
        "Overdue": "Vencido",
        "Next": "Siguiente",
        "Unscheduled": "No Programado",
        "task_assign_to_you": "tarea asignada a ti",
        "Notification_Request": "Solicitud de Notificación",
        "no": "No",
        "yes": "Sí",
        "add_task_type": "Agregar Tipo de Tarea",
        "are_you_sure": "¿Deseas habilitar las notificaciones del navegador?"
    },
    "Header": {
        "Project_Forecasting": "Pronóstico del proyecto (Próximamente)",
        "Resource_Planning": "Planificación de recursos (Próximamente)",
        "Projects": "Proyectos",
        "Time_Sheet": "Hoja de Tiempo",
        "User_Timesheet": "Hoja de Tiempo del Usuario",
        "project_Timesheet": "Hoja de Tiempo del Proyecto",
        "Workload_Timesheet": "Hoja de Tiempo de la Carga de Trabajo",
        "Tracker_Timesheet": "Hoja de Tiempo del Rastreador",
        "Reports": "Informes",
        "Milestone_Report": "Informe de Hitos",
        "Time_Forcasting": "Pronóstico del tiempo",
        "Chat": "Chat",
        "Notification": "Notificación",
        "mention": "Mención",
        "Tours": "Recorridos",
        "Logout": "Cerrar Sesión",
        "Mark_all_as_read": "Marcar todo como leído",
        "Mark_all_as_complete": "Marcar todo como Completo",
        "designation": "Designación",
        "upgrade_now": "Mejorar Ahora",
        "load_more": "Cargar más",
        "take_tour": "Tomar un recorrido",
        "task_details": "Detalles de la Tarea",
        "Comments": "Comentarios",
        "activity_log": "Registro de Actividades",
        "time_log": "Registro de Tiempo",
        "mentions": "Menciones",
        "Notifications": "Notificaciones",
        "no_data_found": "No se encontró datos",
        "search_results": "Resultados de búsqueda",
        "my_profile": "Mi Perfil",
        "billing_history": "Historial de Facturación",
        "Assignee": "Asignado a",
        "Due Date": "Fecha de Vencimiento",
        "Priority": "Prioridad",
        "Key": "Clave",
        "Created Date": "Fecha de Creación",
        "Created By": "Creado Por",
        "advance_search": "Búsqueda Avanzada",
        "for_advance_search": "Para Búsqueda Avanzada",
        "get_more": "¿Obtener más?",
        "to_unlock_activity_view": "Para desbloquear la vista de actividades",
        "AssigneeUserId": "Asignado a",
        "DueDate": "Fecha de Vencimiento",
        "TaskKey": "Clave",
        "Task_Priority": "Prioridad",
        "commentCounts": "Chat",
        "created_by": "Creado Por",
        "created_date": "Fecha de Creación",
        "create_project": "Crear Proyecto",
        "Company": "Compañía"
    },
    "ProjectDetails": {
        "select_project_category": "Seleccionar Categoría de Proyecto",
        "select_currency": "Seleccionar Moneda",
        "description": "Descripción",
        "details": "Detalles",
        "status": "Estado",
        "assignee": "Asignado a",
        "key": "Clave",
        "category": "Categoría",
        "source": "Fuente",
        "type": "Tipo",
        "billing_period": "Periodo de Facturación",
        "currency": "Moneda",
        "amount": "Monto",
        "start_date": "Fecha de Inicio",
        "end_date": "Fecha de Finalización",
        "no_start_date": "Sin Fecha de Inicio",
        "no_end_date": "Sin Fecha de Finalización",
        "no_due_date": "Sin Fecha de Vencimiento",
        "msg": "La fecha de inicio no puede modificarse porque ya está",
        "msgbr": "dentro de un rango de hito.",
        "startdatemsg0": "La fecha de inicio no puede modificarse porque ya está",
        "startdatemsg1": "dentro de un rango de hito.",
        "ok": "Aceptar",
        "lead": "Líder",
        "browse_by_category": "Buscar por categoría",
        "subtask": "Subtarea",
        "details_project_setup": "Detalles de la configuración del Proyecto",
        "avatar": "Avatar",
        "shared_with": "Compartido con",
        "no_user_selected": "No se ha seleccionado ningún usuario",
        "required_view": "Vista requerida",
        "set_the_require": "Establece la(s) vista(s) que requieres. Estas vistas se crearán automáticamente cuando naveges por Proyectos, Carpetas y Listas en BRAND_NAME en lugar de crearlas manualmente. Una vez creadas, las vistas no pueden ser eliminadas.",
        "always_required": "Siempre Requerido",
        "make_default": "Hacer Predeterminado",
        "reporter": "Reportero",
        "copy_task_link": "Copiar enlace de tarea",
        "copy_task_key": "Copiar clave de tarea",
        "add_que_list": "Agregar a la Lista de Cola",
        "remove_que_list": "Eliminar de la Lista de Cola",
        "convert_list": "Convertir a Lista",
        "convert_subtask": "Convertir a Subtarea",
        "merge": "Fusionar",
        "move": "Mover",
        "convert_task": "Convertir a Tarea",
        "no_currency_found": "No se encontró moneda",
        "remove_from_queue_list": "Eliminar de la Lista de Cola",
        "convert": "Convertir",
        "DUPLICATE_AND_OPEN": "Duplicar y Abrir",
        "MOVE_AND_OPEN": "Mover y Abrir",
        "CONVERT_AND_OPEN": "Convertir y Abrir",
        "MERGE_AND_OPEN": "Fusionar y Abrir"
    },
    "ProjectSlider": {
        "new_project": "Nuevo Proyecto",
        "no_archived": "No se encontraron datos archivados",
        "you_dont": "No tienes proyectos",
        "archived_list": "Lista Archivada",
        "projects": "Proyectos",
        "project_name": "Nombre del Proyecto",
        "folder_name": "Nombre de la Carpeta",
        "sprint_name": "Nombre del Sprint",
        "show_archive": "Mostrar Archivo",
        "hide_archive": "Ocultar Archivo",
        "try_using_diff": "Intenta usar diferentes palabras clave",
        "no_project_found": "No se encontraron proyectos",
        "no_result_found": "No se encontraron resultados",
        "select_project_status": "Seleccionar Estado del Proyecto",
        "no_activity_log_found": "No se encontró registro de actividad"
    },
    "Projects": {
        "sprint": "Sprint",
        "folder": "Carpeta",
        "task_view": "Vista de Tarea",
        "default_view": "Vista Predeterminada",
        "add_view": "Agregar Vista",
        "rename": "Renombrar",
        "pin": "Fijar",
        "edit_code": "Editar Código",
        "copy_link": "Copiar Enlace",
        "delete": "Eliminar",
        "view": "Ver",
        "watchers": "Observadores",
        "files_links": "Archivos y Enlaces",
        "audio_files": "Archivos de Audio",
        "project_permissions": "Permisos del Proyecto",
        "color_avatar": "Color y Avatar",
        "duplicate": "Duplicar",
        "close_project": "Cerrar Proyecto",
        "archive": "Archivar",
        "search_in": "Buscar en",
        "expanded": "Expandido",
        "collapsed": "Colapsado",
        "me": "Yo",
        "status": "Estado",
        "priority": "Prioridad",
        "due_date": "Fecha de Vencimiento",
        "group_by": "Agrupar por",
        "subtask": "Subtarea",
        "task_name": "Nombre de la Tarea",
        "task_key": "Clave de Tarea",
        "everyone": "Todos",
        "private": "Privado",
        "share_with": "Compartir con",
        "create_new_list": "Crear Nuevo Sprint",
        "create_new_folder": "Crear Nueva Carpeta",
        "restore": "Restaurar",
        "unpin": "Desfijar Vista",
        "pinview": "Fijar Vista",
        "deleteview": "Eliminar Vista",
        "close": "Cerrar",
        "cancel": "Cancelar",
        "tasks": "Tareas",
        "save": "Guardar",
        "create_project": "Crear Proyecto",
        "use_template": "Usar Plantilla",
        "blank_project": "Proyecto en Blanco",
        "no_category_found": "No se encontró categoría",
        "template": "Plantilla",
        "save_create": "Guardar y Crear",
        "save_tamplete": "Guardar como Plantilla",
        "previous": "Anterior",
        "new_task": "Nueva Tarea",
        "add_subtask": "Agregar Subtarea",
        "list_of_user": "Lista de Usuarios",
        "list_of_project_status": "Lista de Estado del Proyecto",
        "list_of_task_type": "Lista de Tipo de Tarea",
        "list_of_task_status": "Lista de Estado de Tarea",
        "list_cc": "Lista cc",
        "category_list": "Lista de Categorías",
        "created_by": "Creado por",
        "tags": "Etiquetas",
        "task_type": "Tipo de Tarea",
        "workspace": "Espacio de Trabajo",
        "project_color": "Color del Proyecto",
        "search": "Buscar",
        "add_task_need": "Agrega el tipo de tareas que necesitas",
        "what_task_want": "¿Qué tipo de tarea quieres?",
        "no_sub_tasks_found": "No se encontraron subtareas",
        "all_project": "Todo Proyecto",
        "closed_project": "Proyecto Cerrado",
        "go_to_project": "Ir a Proyectos",
        "reopen_project": "Reabrir Proyecto",
        "required_view": "Vistas Requeridas",
        "project_status": "Agregar los estados para el proyecto",
        "what_project": "¿Qué estado de proyecto deseas?",
        "active_status": "Estado Activo",
        "done_status": "Estado Hecho",
        "add_status": "Agregar Estado",
        "close_status": "Cerrar Estado",
        "submit": "Enviar",
        "Audio_Files": "Archivos de Audio",
        "Files_&_Links": "Archivos y Enlaces",
        "no_audio_file": "No se encontraron archivos de audio",
        "change_color": "Cambiar color y avatar",
        "files": "Archivos",
        "links": "Enlaces",
        "about": "Acerca de",
        "result": "resultados",
        "seconds": "segundos",
        "sort_by": "Ordenar por",
        "relevance": "Relevancia",
        "last_update": "Última Actualización",
        "last_created": "Última Creación",
        "issue": "Problema",
        "update": "Actualizar",
        "date": "Fecha",
        "time": "Hora",
        "duration": "Duración",
        "duplicate_task": "Tarea Duplicada",
        "projects": "Proyectos",
        "browse_projects": "Explorar Proyectos",
        "location": "Ubicación",
        "add_new": "Agregar Nuevo",
        "create_compnay": "Crear Compañía",
        "company_name": "Nombre de la Compañía",
        "archived_project": "Proyecto Archivado",
        "assignee_teams": "Equipos Asignados",
        "assignee_user": "Usuarios Asignados",
        "all": "Todos",
        "restore_project": "Restaurar Proyecto",
        "delete_project": "Eliminar Proyecto",
        "items_per_page": "Elementos por Página",
        "Assignee": "Asignado a",
        "Project_Created_Date": "Fecha de Creación del Proyecto",
        "Project_Status": "Estado del Proyecto",
        "Project_Type": "Tipo de Proyecto",
        "Comments_Counts": "Conteo de Comentarios",
        "Created_Date": "Fecha de Creación",
        "Name": "Nombre",
        "Running_Time_Tracker": "Rastreadores de Tiempo en Ejecución",
        "Assigned_to": "Asignado a",
        "Project": "Proyecto",
        "Currency": "Moneda",
        "Milestone_Type": "Tipo de Hito",
        "Project_Category": "Categoría del Proyecto",
        "Comment_Type": "Tipo de Comentario",
        "results_in_time": "Resultados en",
        "create_blank_project": "Crear Proyecto en Blanco",
        "create_project_using_template": "Crear Proyecto Usando Plantilla",
        "choose_apps": "Elija aplicaciones"
    },
    "Watcher": {
        "ignore": "Ignorar",
        "participating_mentions": "Participando y {'@'}menciones",
        "list_of_watcher": "Lista de Observadores",
        "all_activity": "Toda la Actividad",
        "watchers_list": "Lista de Observadores",
        "owner": "Propietario"
    },
    "ViewList": {
        "List": "Lista",
        "Board": "Tablero",
        "Project Details": "Detalles del Proyecto",
        "Comments": "Comentarios",
        "Calendar": "Calendario",
        "Activity": "Actividad",
        "Workload": "Carga de Trabajo",
        "Gantt": "Gantt",
        "Table": "Tabla",
        "Timeline": "Cronograma",
        "Embed": "Incorporar",
        "Comment": "Comentario",
        "to_unlock_list_view": "Para desbloquear la vista de lista",
        "error_message_for_empty": "Por favor, seleccione al menos una vista",
        "set_as_default": "Establecer como predeterminado",
        "remove_as_default": "Eliminar como predeterminado"
    },
    "Apps": {
        "tags": "Etiquetas",
        "Priority": "Prioridad",
        "TimeEstimates": "Estimación de Tiempo",
        "Milestones": "Hitos",
        "MultipleAssignees": "Varios Asignados",
        "CustomFields": "Campos Personalizados",
        "TimeTracking": "Seguimiento de Tiempo",
        "AI": "IA"
    },
    "Tags": {
        "no_tags_found": "No se encontraron etiquetas",
        "search_or_create_new": "Buscar o Crear Nueva",
        "change_color": "Cambiar Color",
        "delete_tag": "Eliminar Etiqueta",
        "delete_tag_desc": "¿Estás seguro de que deseas eliminar la etiqueta en todo este Espacio?",
        "note_msg": "Presiona Enter para crear una nueva etiqueta",
        "This_tag_has_already_been_added": "Esta etiqueta ya ha sido añadida",
        "Tag_name_required": "Se requiere nombre de etiqueta"
    },
    "Embeded": {
        "Anything": "Cualquier cosa",
        "Sheets": "Hojas de Google",
        "Docs": "Documentos de Google",
        "Youtube": "Youtube",
        "Figma": "Figma",
        "The_name_is_required": "El nombre es obligatorio",
        "The_name_should_be_at_least_3_characters_long": "El nombre debe tener al menos 3 caracteres",
        "The_url_is_required": "La URL es obligatoria",
        "Please_enter_valid_url": "Por favor ingrese una URL válida",
        "URL_already_exists": "La URL ya existe",
        "The_Html_code_is_required": "El código HTML es obligatorio",
        "name_already_exists": "Este nombre ya existe",
        "to_unlock_embed_view": "Para desbloquear la vista de incrustación"
    },
    "ViewListdescription": {
        "list_view": "Usa la vista de lista para organizar tus tareas de la manera que imagines: ordenar, filtrar, agrupar y personalizar columnas.",
        "kanban_view": "Construye tu tablero perfecto y mueve fácilmente las tareas entre las columnas.",
        "projectdetail_view": "Agrega requisitos iniciales, lista de verificación y adjuntos para que tu equipo entienda en detalle.",
        "Comments_view": "Agrega comentarios en tiempo real sobre cualquier cosa con tu equipo para que reciban notificaciones y puedan responder.",
        "calender_view": "La vista de calendario es tu lugar para planificación, programación y gestión de recursos.",
        "table_view": "Gestiona, actualiza y organiza tus tareas fácilmente con la vista de tabla.",
        "workload_view": "Ve la capacidad de tu equipo, quién está sobrecargado o tiene poca carga y reasigna tareas según sea necesario.",
        "activitylog_view": "Obtén una vista agregada de toda la actividad a través de una ubicación. Filtra por personas y tipo para obtener un detalle de la actividad que ves.",
        "add_msg1": "Agrega aplicaciones y sitios web junto a tus tareas con la vista de incorporar",
        "add_msg2": "para ahorrar tiempo y reducir el cambio de contexto.",
        "view_name": "Nombre de la Vista",
        "embed_URL": "URL de Incrustación",
        "embed_HTML": "HTML de Incrustación",
        "private_view": "Vista Privada"
    },
    "Filters": {
        "filter": "Filtros",
        "learnmorefilter": "Aprende más sobre filtros",
        "pleaseselectvalid": "Por favor selecciona todas las opciones válidas",
        "confirm": "Confirmar",
        "are_you_sure": "¿Estás seguro de que deseas eliminar?",
        "clearall": "Limpiar todo",
        "addfilter": "Agregar Filtro",
        "where": "Dónde",
        "filtering_field": "Campo de filtrado",
        "no_date_found": "No se encontraron fechas",
        "save_this_filters": "Guardar estos filtros",
        "save_filter": "Guardar filtro",
        "save": "Guardar",
        "update_filter": "Actualizar filtro",
        "my_filter": "Mi filtro",
        "no_data_found": "No se encontraron datos",
        "show_result": "Mostrar resultados",
        "save_filters": "Guardar filtros",
        "filter_by": "Filtrar por",
        "projects": "Proyectos",
        "teams": "Equipos",
        "user": "Usuario",
        "no_comment_found": "No se encontraron comentarios",
        "no_project_found": "No se encontraron proyectos",
        "no_file_found": "No se encontraron archivos",
        "no_link_found": "No se encontraron enlaces",
        "filter_operator": "Operador de filtro",
        "options": "Opciones",
        "priorities": "Prioridades",
        "select_all": "Seleccionar todo",
        "milestone_type": "Tipo de hito",
        "comment_type": "Tipo de comentario",
        "a_to_z": "De A a Z",
        "no_files_found": "No se encontraron archivos",
        "no_links_found": "No se encontraron enlaces",
        "no_links_or_files_found": "No se encontraron enlaces ni archivos",
        "z_to_a": "De Z a A",
        "sort_by": "Ordenar por",
        "A-Z": "De A a Z",
        "Ascending": "Ascendente",
        "Descending": "Descendente",
        "No": "No",
        "Yes": "Sí",
        "Z-A": "De Z a A",
        "Save_this_Filter": "Guardar este filtro",
        "Enter_Filter_Name": "Ingresa el nombre del filtro",
        "Select_Options": "Seleccionar opciones",
        "Equal_To": "Igual a",
        "Greater_Than": "Mayor que",
        "Is": "Es",
        "Less_Than": "Menor que",
        "Clear_All": "Limpiar todo",
        "select_assignee": "Seleccionar Asignado",
        "select_project_types": "Seleccionar Tipos de Proyecto",
        "unselect_all": "Desmarcar todo",
        "are_you_suredelete": "¿Estás seguro de que deseas eliminar?",
        "Not_Equals_To": "No es"
    },
    "conformationmsg": {
        "archive": "Una lista se puede archivar para ocultarla de la vista, pero se puede restaurar en cualquier momento. Todas las tareas se mantienen y siguen siendo buscables cuando archivas una lista.",
        "delete": "Las tareas y plantillas de este proyecto serán borradas. Escribe el nombre del proyecto para confirmar que realmente deseas eliminar todas las tareas, plantillas y este proyecto.",
        "archive0mesg": "Escribe el nombre del proyecto para confirmar que realmente deseas cerrar este proyecto",
        "sprintclosemsg": "Escribe el nombre del sprint para confirmar que realmente deseas cerrar este sprint",
        "type": "Escribe",
        "are_you_sure": "¿Estás seguro?",
        "no_revert_msg": "¡No podrás revertir esto!",
        "yes_delete": "¡Sí, elimínalo!",
        "task_will_become_subtasks_of": "la tarea se convertirá en subtareas de",
        "Are_you_sure_you_want_to_delete": "¿Estás seguro de que deseas eliminar",
        "subtasks_will_become_subtasks_of": "Las subtareas se convertirán en subtareas de",
        "unlock_board_view": "Para desbloquear la vista de tablero",
        "unlock_project_detail_view": "Para desbloquear la vista de detalles del proyecto",
        "unlock_table_view": "Para desbloquear la vista de tabla",
        "unlock_workload_view": "Para desbloquear la vista de carga de trabajo",
        "to_unlock_tracker_timesheet": "Para desbloquear la hoja de tiempo del rastreador",
        "to_unlock_user_timesheet": "Para desbloquear la hoja de tiempo del usuario",
        "unlock_calendar_view": "Para desbloquear la vista del calendario"
    },
    "Description": {
        "description": "Descripción",
        "edit": "Editar",
        "add_description": "Agregar una descripción",
        "show_more": "Mostrar más",
        "show_less": "Mostrar menos",
        "description_placeholder": "Escribe algo o escribe '/' para comandos y acciones de IA",
        "saved": "Guardado"
    },
    "Checklist": {
        "checklist": "Lista de verificación",
        "add_checklist": "Agregar una lista de verificación",
        "suggest_checklists": "Sugerir listas de verificación",
        "Checklists": "Listas de verificación",
        "to_unlock_checklist": "Para desbloquear la lista de verificación"
    },
    "Attachments": {
        "attachments": "Archivos adjuntos",
        "drag_file": "Aquí también puedes arrastrar y soltar archivos.",
        "see_all": "Ver todos",
        "drop_file": "Suelta archivos aquí para adjuntar o",
        "browse": "Buscar",
        "no_preview_found": "No se encontró vista previa",
        "show_all_pages": "Mostrar todas las páginas",
        "drop_here": "Suelta aquí"
    },
    "Milestone": {
        "milestone": "Hito",
        "milestone_name": "Nombre del hito",
        "status_date": "Fecha de estado",
        "total_amount": "Monto total",
        "are_you_sure": "¿Estás seguro de que deseas eliminar el hito?",
        "add_new": "Agregar un nuevo",
        "mileston_status": "Estado del hito",
        "project_name": "Nombre del proyecto",
        "end_date": "Fecha de finalización",
        "start_date": "Fecha de inicio",
        "estimated_release": "Liberación estimada",
        "release_request_sent": "Solicitud de liberación enviada",
        "released": "Liberado",
        "not_funded": "No financiado",
        "funded": "Financiado",
        "project_milestone_Status": "Estado del hito del proyecto",
        "milestone_status_name": "Nombre del estado del hito",
        "date_displaye": "Fecha mostrada en el calendario",
        "past": "Pasado",
        "feature": "Futuro",
        "milestone_weekly_range": "Rango semanal del hito",
        "file_extensions": "Extensiones de archivo",
        "avatar": "Avatar",
        "adding_estimated": "Agregar horas estimadas",
        "range": "Rango",
        "user": "Usuario",
        "refunded_amount": "Monto reembolsado",
        "Max_2_decimal_places_allowed": "Se permiten un máximo de 2 decimales",
        "The_refunded_amount_field_should_not_be_more_then_amount": "El campo de monto reembolsado no debe ser mayor que el monto",
        "Amount_field_should_not_be_smaller_than_the_refunded_amount": "El campo de monto no debe ser menor que el monto reembolsado",
        "The_minute_field_must_be_59_or_less": "El campo de minutos debe ser 59 o menos",
        "The_hours_field_is_required": "El campo de horas es obligatorio",
        "Name_already_exists": "El nombre ya existe",
        "The_milestone_status_field_is_required": "El campo de estado del hito es obligatorio",
        "The_milestone_status_field_must_be_at_leat_characters": "El campo de estado del hito debe tener al menos 3 caracteres",
        "actual_amount": "Monto actual",
        "partially_refunded": "Parcialmente reembolsado",
        "refunded_amount_should_not_exceed_amount": "El monto reembolsado no debe exceder el monto",
        "total_partially_refunded": "Total parcialmente reembolsado",
        "field_should_not_be_smaller_than_refund_amount": "El campo no debe ser menor que el monto del reembolso",
        "white_color_not_allowed": "No se permite el color blanco. Por favor selecciona un color válido",
        "billing": "Facturación",
        "per_hour": "Por hora",
        "adding_taskPlanning": "Agregar planificación de tareas"
    },
    "Comment": {
        "created_by": "Creado por",
        "created_on": "Creado el",
        "task_name": "Nombre de la tarea"
    },
    "UserTimesheet": {
        "back_projects": "Volver a Proyectos",
        "user_timesheet": "Hoja de Tiempo del Usuario",
        "back": "Volver",
        "tracked_time": "Tiempo registrado",
        "manual_time": "Tiempo manual",
        "users": "Usuarios",
        "logged": "Registrado",
        "hours": "Horas",
        "estimated": "Estimado",
        "no_records_found": "No se encontraron registros",
        "project_timesheet": "Hoja de Tiempo del Proyecto",
        "tracker_timesheet": "Hoja de Tiempo del Rastreador",
        "workload_timesheet": "Hoja de Tiempo de Carga de Trabajo",
        "milestone_reports": "Informes de Hitos",
        "add_time": "Agregar Tiempo",
        "add_time_log": "Agregar Registro de Tiempo",
        "edit_time_log": "Editar Registro de Tiempo",
        "Teams": "Equipos",
        "Users": "Usuarios",
        "Projects": "Proyectos",
        "task_planning": "Planificación de tareas",
        "task_remaining_planning": "Horas restantes",
        "planned": "Planificado"
    },
    "ProjectWorkplace": {
        "msg1": "El proyecto puede ser compartido con miembros. Puedes agregar invitados a Carpetas, Listas y tareas después de crear un Proyecto.",
        "msg2": "Actualmente no hay planes para crear proyectos privados o públicos. Si deseas iniciar un proyecto, sería necesario actualizar tu plan."
    },
    "CustomField": {
        "custom_field": "Campo Personalizado",
        "create_custom_field": "Crear Campo Personalizado",
        "lable": "Etiqueta",
        "action": "Acción",
        "add_custom_field": "Agregar Campo Personalizado",
        "add_new_custom_field": "Agregar Nuevo Campo Personalizado",
        "field_name": "Nombre del Campo",
        "date_created": "Fecha de Creación",
        "add_another_item": "Agregar otro ítem",
        "choose_ready_made_list": "Elige una lista prehecha de opciones (por ejemplo, días, meses, etc.)",
        "predefined_options": "Opciones Predefinidas",
        "selected_by_default": "Seleccionado por defecto",
        "allow_time_with_date": "Permitir a los usuarios especificar una hora con la fecha.",
        "date_format": "Formato de Fecha",
        "days_of_week": "Días de la semana",
        "past_and_future": "Pasado y Futuro",
        "select_date_format": "Selecciona un formato de fecha. D significa día, M para mes y Y para año.",
        "select_dates_past_future": "Permitir a los usuarios seleccionar fechas en el pasado o futuro",
        "select_time_format": "Seleccionar formato de hora",
        "time_format": "Formato de hora",
        "unchecking_day_calendar": "Desmarcar un día hará que no esté disponible en el calendario",
        "future": "Futuro",
        "past": "Pasado",
        "enter_maximum_limit": "Ingresa el Límite Máximo",
        "enter_minimum_limit": "Ingresa el Límite Mínimo",
        "limit_minimum_or_maximum_value": "Limitar el valor mínimo o máximo permitido para este campo",
        "maximum_limit_type_not_allowed_value": "El valor ingresado para el Tipo de Límite Máximo no es un valor permitido.",
        "maximum_value_should_be_greater_than_minimum_value": "El valor máximo debe ser mayor que el valor mínimo",
        "minimum_limit_type_not_allowed_value": "El valor ingresado para el Tipo de Límite Mínimo no es un valor permitido.",
        "minimum_value_should_not_be_greater_than_maximum_value": "El valor mínimo no debe ser mayor que el valor máximo",
        "no_country_found": "No se encontró ningún país",
        "enter_maximum_limit_type": "Ingresa el Tipo de Límite Máximo",
        "enter_minimum_limit_type": "Ingresa el Tipo de Límite Mínimo",
        "limit_minimum_or_maximum_text_allowed": "Limitar la cantidad mínima o máxima de texto permitido en este campo",
        "max_should_be_greater_than_min": "El máximo debe ser mayor que el mínimo",
        "min_should_be_less_than_max": "El mínimo debe ser menor que el máximo",
        "separator": "Separador",
        "countryCode": "Actívalo para modificar el código de país."
    },
    "Category": {
        "cateory_name": "Nombre de la Categoría",
        "create_category": "Crear Categoría",
        "create_channel": "Crear Canal",
        "no_chat_found": "No se encontraron chats",
        "upgradeplanemsg": "Para acceder a esta función, por favor actualiza tu plan."
    },
    "Channel": {
        "create_channel": "Crear Canal",
        "msg1": "Has alcanzado el límite máximo de creación de canales públicos y privados. Para acceder a esta función, por favor actualiza tu plan",
        "channel_name": "Nombre del Canal",
        "icons": "Íconos",
        "or": "o",
        "only_share_with": "Solo compartir con",
        "private_channel": "Canal Privado",
        "msg2": "Solo los miembros y roles seleccionados podrán ver este canal",
        "allowmsg2": "Permite a los miembros enviar mensajes en este canal",
        "send_messages": "Enviar Mensajes",
        "choose_to_upload": "Elige una Imagen para Subir",
        "private_channel_limit_reached": "Has alcanzado el límite de creación de canales privados. Solo puedes crear canales públicos. Si deseas crear un canal privado, por favor actualiza tu plan.",
        "public_channel_limit_reached": "Has alcanzado el límite de creación de canales públicos. Solo puedes crear canales privados. Si deseas crear un canal público, por favor actualiza tu plan."
    },
    "Templates": {
        "delete_template": "Eliminar Plantilla",
        "project_status": "Estado del Proyecto",
        "task_status": "Estado de la Tarea",
        "no_app_selected": "No se han seleccionado aplicaciones",
        "default_views": "Configuración predeterminada de vistas",
        "apps": "Aplicaciones",
        "add_new_templete": "Agregar Nueva Plantilla",
        "templates": "Plantillas",
        "s": "s",
        "template_name": "Nombre de la Plantilla",
        "upload_image": "Subir Imagen",
        "all_good": "Todo bien",
        "create_template": "Crear Plantilla",
        "new_template": "Nueva Plantilla",
        "remove": "Eliminar",
        "enable_apps": "Habilitar Aplicaciones",
        "Turn": "Activar",
        "all_apps": "todas las Aplicaciones",
        "off": "desactivado",
        "on": "activado",
        "upload": "Subir",
        "save_template": "Guardar Plantilla",
        "setup_status": "Configurar los estados para las tareas",
        "what_task": "¿Qué estado de tarea deseas?",
        "select_task_status": "Seleccionar Estado de Tarea",
        "delete_template_confirmation": "¿Estás seguro de que deseas eliminar la plantilla?",
        "ai_sidebar_title": "Crear plantilla con IA",
        "ai_label_category": "Categoría",
        "ai_label_description": "Descripción",
        "ai_button_text_requested_changes": "Solicitar cambios",
        "ai_min_view_msg_text": "Se requiere al menos una vista",
        "ai_min_msg_text": "Se requieren al menos 10 caracteres",
        "ai_before_desc_placeholder": "Ingrese la descripción del caso de uso para generar una plantilla",
        "ai_after_desc_placeholder": "Aquí puede seguir pidiendo cambios relevantes",
        "try_with_ai": "Prueba con IA",
        "msg_search_result_found": "Aquí hay algunas plantillas sugeridas que se ajustan a tus necesidades. Puedes seleccionar cualquiera o hacer clic para crear una con IA",
        "msg_search_result_not_found": "No se encontraron plantillas relevantes. Para crear una con IA, simplemente haz clic"
    },
    "Settings": {
        "add_new_projects": "Agregar Nuevo Proyecto",
        "task_priority": "Prioridad de la Tarea",
        "maximum_image_size": "Tamaño máximo de imagen",
        "warning": "Advertencia",
        "cant_delete": "no se puede eliminar",
        "priority_in_use": "El usuario no puede eliminar la prioridad PRIORITY_NAME ya que está en uso.",
        "company_name": "Nombre de la Empresa",
        "phone": "Teléfono",
        "country": "País",
        "state": "Estado",
        "city": "Ciudad",
        "select_date_format": "Seleccionar Formato de Fecha",
        "save_changes": "Guardar Cambios",
        "currencies": "Monedas",
        "add_remove_cur": "Agregar/Eliminar Monedas",
        "change_image": "Cambiar Imagen",
        "Priorities_already_Exists": "Las prioridades ya existen",
        "The_priority_image_field_is_required": "El campo de imagen de prioridad es obligatorio",
        "The_priority_name_field_is_required": "El campo de nombre de prioridad es obligatorio",
        "The_priority_name_field_must_be_at_least": "El campo de nombre de prioridad debe tener al menos 3 caracteres",
        "The file extension field is required": "El campo de extensión de archivo es obligatorio",
        "The_file_extension_field_must_be_at_least": "El campo de extensión de archivo debe tener al menos 3 caracteres",
        "file_extension_is_not_supported": "La extensión de archivo no es compatible",
        "file_extension_already_Exists": "La extensión de archivo ya existe",
        "The_file_extension_field_is_required": "El campo de extensión de archivo es obligatorio."
    },
    "Members": {
        "invite": "Invitar",
        "all_members": "Todos los miembros",
        "removed_members": "Miembros eliminados",
        "name": "Nombre",
        "role": "Rol",
        "last_active": "Última actividad",
        "time_tracker": "Rastreador de tiempo",
        "settings": "Configuración",
        "removeuser": "Eliminar usuario",
        "adduser": "Añadir usuario",
        "invite_user": "Invitar usuario",
        "remove_request": "Eliminar solicitud",
        "resend_invitation": "Reenviar invitación",
        "cancel_invitation": "Cancelar invitación",
        "Invitation_mail_sent_sucessfully": "Correo de invitación enviado con éxito",
        "confirm_change_user_designation": "¿Estás seguro de que quieres cambiar la designación de este usuario a",
        "confirm_change_user_role": "¿Estás seguro de que quieres cambiar el rol de este usuario a",
        "Import_users_from_csv": "Importar usuarios desde CSV"
    },
    "Upgrades": {
        "take_next_step": "Da el siguiente paso con tu trabajo",
        "you_are_on": "Actualmente estás en el",
        "per_year": "Por año",
        "per_month": "Por mes",
        "current_plane": "Plan actual",
        "per_member": "Por miembro",
        "and_much_more": "y mucho más",
        "upgrade_to": "Actualizar a",
        "select_payment_method": "Seleccionar método de pago",
        "plan": "Plan",
        "plane_upgrade": "Actualización de plan exitosa",
        "plane_upgrade_msg": "¡Actualización de plan exitosa! Tu suscripción ha sido actualizada. Por favor, espera entre 2 y 3 minutos para que los cambios tengan efecto en todas partes, asegurándote de que puedas disfrutar completamente de las características ampliadas y mejoras.",
        "something_wrong": "Algo salió mal. Por favor, inténtalo de nuevo",
        "unsucessfull_msg": "Actualización de plan no exitosa. Encontramos un problema al actualizar tu plan. Por favor, intenta nuevamente o contacta con el soporte para obtener ayuda.",
        "upgrade_your_plan": "Actualiza tu plan",
        "to_unlock_custom_field": "Para desbloquear el campo personalizado",
        "unlimited": "Ilimitado",
        "the_feature_not_available": "Esa función no está disponible en tu plan actual",
        "unlock_project_permission": "Para desbloquear los permisos de proyecto",
        "unlock_custom_field": "Para desbloquear el campo personalizado",
        "to_unlock_milestone": "Para desbloquear el hito",
        "to_unlock_milestone_report": "Para desbloquear el informe de hito",
        "to_unlock_security": "Para desbloquear Seguridad y Permisos",
        "to_unlock_team": "Desbloquear equipo",
        "to_unlcok_project": "Para desbloquear el proyecto",
        "You_have_reached_the_free_plan_limit": "Has alcanzado el límite de PLAN_NAME",
        "require_upgrade_message": "Puedes crear hasta PROJECT_COUNT proyectos en el plan PROJECT_NAME. Crea más tableros actualizando tu plan.",
        "are_you_sure_you_want_to_update": "¿Estás seguro de que deseas actualizar?",
        "find_out_whats_included_in_this_update": "Descubre qué está incluido en esta actualización",
        "improved_performance": "Rendimiento mejorado",
        "install_now": "Instalar ahora",
        "later": "Más tarde",
        "please_see_below_for_a_list_of_changes_to_the_features": "Por favor, consulta a continuación para ver una lista de cambios en las características.",
        "to_integrate_new_services_into_an_alian_hub": "Para integrar nuevos servicios en Hyphen OI Pro.",
        "whats_new": "¿Qué hay de nuevo?",
        "check_to_agree_with_above_points": "Marca para estar de acuerdo con los puntos anteriores",
        "general_notes": "Notas generales",
        "update_now": "Actualizar ahora",
        "unlock_channel": "Para desbloquear canal",
        "unlock_chat": "Para desbloquear chat",
        "unlock_one_chat": "Para desbloquear chat uno a uno",
        "public_private_creation_time_limit_reached": "Ha alcanzado el límite para la creación de proyectos. Si desea crear un proyecto, actualice su plan.",
        "public_creation_time_limit_reached": "Ha alcanzado el límite para la creación de proyectos públicos. Solo puede crear proyectos privados. Si desea crear un proyecto público, actualice su plan.",
        "private_creation_time_limit_reached": "Ha alcanzado el límite para la creación de proyectos privados. Solo puede crear proyectos públicos. Si desea crear un proyecto privado, actualice su plan."
    },
    "Permissions": {
        "advanced_permission": "Permisos avanzados",
        "allow_admins": "Permitir que los administradores gestionen Espacios privados",
        "when_admin_enable": "Cuando esté habilitado, los administradores podrán añadir/quitar personas y transferir la propiedad de todos los Espacios.",
        "show_all_projects": "Mostrar todos los proyectos",
        "when_user_enable": "Cuando esté habilitado, los usuarios podrán ver todos los proyectos globales.",
        "show_all_task": "Mostrar todas las tareas",
        "when_user_enable_sprint": "Cuando esté habilitado, los usuarios podrán ver todas las tareas en los sprints.",
        "own": "Propio",
        "select": "Seleccionar",
        "Member": "Miembro",
        "Guest": "Invitado",
        "None": "Ninguno",
        "Read": "Leer",
        "add_new_team": "Añadir nuevo equipo",
        "Read & Write": "Leer y Escribir",
        "Support": "Soporte",
        "select_priorities": "Seleccionar prioridades",
        "apply_permission": "Aplicar permiso",
        "project_permission_description": "Para anular los permisos globales, está deshabilitado por defecto. Una vez habilitado, podrás gestionar los permisos de proyectos y tareas. Si está deshabilitado, se aplican los permisos globales",
        "project_permission_title_disable": "La capacidad para otorgar permisos personalizados para este proyecto se desactivará",
        "project_permission_title_enable": "La capacidad para otorgar permisos personalizados para este proyecto se habilitará",
        "reset_permission": "Restablecer permiso"
    },
    "subProjectRulesNames": {
        "Project_List": "Lista de proyectos",
        "Project_Create": "Crear proyecto",
        "Project_Name_Edit": "Editar nombre del proyecto",
        "Project_Sprint_Create": "Crear sprint del proyecto",
        "Project_folder_Create": "Crear carpeta del proyecto",
        "Project_folder_Name_Edit": "Editar nombre de la carpeta del proyecto",
        "Project_sprint_Name_Edit": "Editar nombre del sprint del proyecto",
        "Project_Details": "Detalles del proyecto",
        "Project_Status_Change": "Cambio de estado del proyecto",
        "Project_Assignee": "Asignar proyecto",
        "Project_Category": "Categoría del proyecto",
        "Proejct_Source": "Fuente del proyecto",
        "Project_Type": "Tipo de proyecto",
        "Project_Currency": "Moneda del proyecto",
        "Project_Amount": "Monto del proyecto",
        "Project_Start Date": "Fecha de inicio del proyecto",
        "Project_End Date": "Fecha de fin del proyecto",
        "Project_Due Date": "Fecha de vencimiento del proyecto",
        "Project_Close": "Cerrar proyecto",
        "Project_Description": "Descripción del proyecto",
        "Project_Checklist": "Lista de verificación del proyecto",
        "Project_Checklist_Assign/remove": "Asignar/quitar lista de verificación del proyecto",
        "Project_Attachments": "Archivos adjuntos del proyecto",
        "Project_Milestone": "Hito del proyecto",
        "Task_list": "Lista de tareas",
        "Task_Create": "Crear tarea",
        "Sub_Task_Create": "Crear subtarea",
        "Task_Name_Edit": "Editar nombre de la tarea",
        "Task_Status": "Estado de la tarea",
        "Task_Assignee": "Asignar tarea",
        "Task_Priority": "Prioridad de la tarea",
        "Task_Due_Date": "Fecha de vencimiento de la tarea",
        "Task_Estimated_Hours": "Horas estimadas de la tarea",
        "Task_Description": "Descripción de la tarea",
        "Task_Checklist": "Lista de verificación de la tarea",
        "Task_Checklist_Assign/remove": "Asignar/quitar lista de verificación de la tarea",
        "Task_Attachments": "Archivos adjuntos de la tarea",
        "Show_Tasks": "Mostrar tareas",
        "Custom_Field": "Campo personalizado",
        "Edit_Company": "Editar empresa",
        "File_Extensions": "Extensiones de archivo",
        "Project_Milestone_Status": "Estado del hito del proyecto",
        "Invite_Member": "Invitar miembro",
        "Member_list": "Lista de miembros",
        "Create_Team": "Crear equipo",
        "Team_List": "Lista de equipos",
        "Security_&_Permissions": "Seguridad y permisos",
        "Role_Management": "Gestión de roles",
        "Designation": "Designación",
        "Milestone_Weekly_Range": "Rango semanal del hito",
        "User_Timesheet": "Hoja de tiempo del usuario",
        "Project_Timesheet": "Hoja de tiempo del proyecto",
        "Workload__Timesheet": "Hoja de tiempo de carga de trabajo",
        "Milestone_Report": "Informe de hito",
        "Project": "Proyecto",
        "Task": "Tarea",
        "Company_Settings": "Configuración de la empresa",
        "Sheet_Settings": "Configuración de la hoja",
        "Team_Color": "Color del equipo",
        "Team_Name": "Nombre del equipo",
        "Add_Member": "Añadir miembro",
        "Add_New_Designation": "Añadir nueva designación"
    },
    "Notification": {
        "Notification": "Notificación",
        "notification_setting": "Configuración de notificaciones",
        "browser": "Navegador",
        "mobile": "Móvil",
        "before": "Antes",
        "chat": "Chat",
        "project": "Proyecto",
        "tasks": "Tareas",
        "before_project_due_date": "Fecha de vencimiento del proyecto",
        "before_project_end_date": "Fecha de finalización del proyecto",
        "before_task_due_date": "Fecha de vencimiento de la tarea",
        "before_task_end_date": "Fecha de finalización de la tarea",
        "message_create": "Crear mensaje",
        "project_create": "Crear proyecto",
        "project_name": "Nombre del proyecto",
        "project_status_change": "Cambio de estado del proyecto",
        "project_assignee": "Asignado al proyecto",
        "project_lead": "Líder del proyecto",
        "project_category": "Categoría del proyecto",
        "project_source": "Fuente del proyecto",
        "project_type": "Tipo de proyecto",
        "project_currency": "Moneda del proyecto",
        "project_amount": "Monto del proyecto",
        "project_start_date": "Fecha de inicio del proyecto",
        "project_end_date": "Fecha de finalización del proyecto",
        "project_due_date": "Fecha de vencimiento del proyecto",
        "project_close": "Cerrar proyecto",
        "project_description": "Descripción del proyecto",
        "project_checklist": "Lista de verificación del proyecto",
        "project_checklist_assign": "Asignar lista de verificación del proyecto",
        "project_checklist_remove": "Eliminar lista de verificación del proyecto",
        "project_attachments": "Archivos adjuntos del proyecto",
        "project_milestone": "Hito del proyecto",
        "project_milestone_status_change": "Cambio de estado del hito del proyecto",
        "project_sprint_create": "Crear sprint del proyecto",
        "project_folder_create": "Crear carpeta del proyecto",
        "comments_im_@mentioned_in": "Comentarios en los que me han mencionado",
        "task_notification": "Notificación de tarea",
        "task_create": "Crear tarea",
        "task_edit": "Editar tarea",
        "task_status": "Estado de la tarea",
        "task_assignee": "Asignado a la tarea",
        "task_priority": "Prioridad de la tarea",
        "task_type": "Tipo de tarea",
        "task_due_date": "Fecha de vencimiento de la tarea",
        "task_description": "Descripción de la tarea",
        "task_checklist": "Lista de verificación de la tarea",
        "task_checklist_assign": "Asignar lista de verificación de la tarea",
        "task_checklist_remove": "Eliminar lista de verificación de la tarea",
        "task_attachments": "Archivos adjuntos de la tarea",
        "comments_Im_@mentioned_in": "Comentarios en los que me han mencionado",
        "logged_hours_notification": "Notificación de horas registradas",
        "after_3_hours_today_pending_hours": "Después de 3 horas, notificación de horas pendientes del día",
        "task_estimated_hours": "Horas estimadas de la tarea"
    },
    "TimeTracker": {
        "TimeTracker": "Rastreador de Tiempo",
        "unlock": "¡Desbloquea el Universo con Hyphen OI Pro Tracker en tu Escritorio!",
        "smooth": "Rastrea suavemente las horas que los usuarios pasan trabajando en proyectos o tareas con el seguimiento de tiempo.",
        "click": "haz clic",
        "No_Record_Found": "No se encontró registro",
        "total": "Total",
        "screenshot_preview": "Vista previa de la captura de pantalla",
        "log_time_found_no_screenshot": "Se encontró el tiempo registrado, pero no se capturó ninguna captura de pantalla para esta duración."
    },
    "settingslider": {
        "Time Tracking": "Seguimiento de Tiempo",
        "Notifications": "Notificaciones",
        "Company": "Compañía",
        "My Settings": "Mis Configuraciones",
        "Security & Permissions": "Seguridad y Permisos",
        "Upgrade": "Actualizar",
        "Custom Field Manager": "Administrador de Campos Personalizados",
        "Templates": "Plantillas",
        "Projects": "Proyectos",
        "Teams": "Equipos",
        "Members": "Miembros",
        "Settings": "Configuraciones",
        "Change Password": "Cambiar la contraseña"
    },
    "Chat": {
        "welcome_message": "Bienvenido a BRAND_NAME",
        "msg2": "Este es un grupo nuevo. Aquí tienes algunos pasos para ayudarte a comenzar. Para más información, consulta nuestra guía de inicio.",
        "chats": "Chats",
        "favorites": "Favoritos",
        "CHANNELS": "CANAL"
    },
    "Comments": {
        "unread_message": "Mensajes no leídos",
        "more": "más",
        "less": "menos",
        "edited": "editado",
        "edit": "Editar",
        "create_task": "Crear Tarea",
        "add_to_checklist": "Agregar a la lista de verificación",
        "copy_message": "Copiar Mensaje",
        "reply": "Responder",
        "message": "Mensaje",
        "mark_unread": "Marcar como no leído",
        "This_message_is_deleted": "Este mensaje ha sido eliminado",
        "You_deleted_this_message": "Tú eliminaste este mensaje",
        "no_user_found": "No se encontró usuario",
        "unlock_comment_view": "Para desbloquear la vista de comentarios"
    },
    "PlaceHolder": {
        "enter_task_type": "Ingresa el tipo de tarea",
        "enter_task_status": "Ingresa el estado de la tarea",
        "enter_project_status": "Ingresa el estado del proyecto",
        "Enter_Project_Name": "Ingresa el nombre del proyecto",
        "Enter_Key_Name": "Ingresa el nombre de la clave",
        "Select_Category": "Selecciona una categoría",
        "Select_Project_Due_Date": "Selecciona la fecha de vencimiento del proyecto",
        "search": "Buscar",
        "search_here": "Buscar aquí",
        "Type_here": "Escribe aquí",
        "Task_name": "Nombre de la tarea",
        "Add_description": "Agregar descripción",
        "Enter_Duplicate_Task_Name": "Ingresa un nombre de tarea duplicado",
        "Enter_Text": "Ingresa texto",
        "Enter_Amount": "Ingresa cantidad",
        "Select": "Seleccionar",
        "Enter_Refund_Amount": "Ingresa la cantidad de reembolso",
        "Enter_Milestone_Name": "Ingresa el nombre del hito",
        "Enter_sprint_name": "Ingresa el nombre del sprint",
        "Enter_directory_name": "Ingresa el nombre del directorio",
        "Rename_Tag": "Renombrar etiqueta",
        "Enter_Team_Name": "Ingresa el nombre del equipo",
        "Duration_only_hours": "Duración solo en horas",
        "Enter_option": "Ingresa opción",
        "Enter_View_Name": "Ingresa el nombre de la vista",
        "Enter_URL": "Ingresa la URL",
        "Enter_HTML": "Ingresa HTML",
        "Enter_item_name": "+ Ingresa el nombre del ítem",
        "Add_an_item": "+ Agregar un ítem",
        "Enter_Company_Name": "Ingresa el nombre de la compañía",
        "Select_Country": "Selecciona el país",
        "Enter_Template": "Ingresa la plantilla",
        "Enter_Template_Name": "Ingresa el nombre de la plantilla",
        "Project_key_must_be_unique": "La clave del proyecto debe ser única",
        "Enter_zip": "Ingresa el código postal",
        "Enter_GST_Number": "Ingresa el número GST",
        "Enter_Milestone_Status": "Ingresa el estado del hito",
        "Enter_Priority_Name": "Ingresa el nombre de la prioridad",
        "Enter_File_Extensions_Name": "Ingresa el nombre de la extensión de archivo",
        "Enter_Task_Name": "Ingresa el nombre de la tarea",
        "Select_State": "Selecciona el estado",
        "No_States": "No hay estados",
        "Select_City": "Selecciona la ciudad",
        "No_Cities": "No hay ciudades",
        "enter_category_name": "Ingresa el nombre de la categoría",
        "enter_channel_name": "Ingresa el nombre del canal",
        "Pinned_messages": "Mensajes fijados",
        "Search": "Buscar",
        "Search_by_name_or_email": "Buscar por nombre o correo electrónico",
        "Invite_by_email": "Invitar por correo electrónico",
        "Select_Designation": "Selecciona la designación",
        "Select_Role": "Selecciona el rol",
        "Enter_designation": "Ingresa la designación",
        "Enter_Description": "Ingresa la descripción",
        "Add_New_Role": "Agregar nuevo rol",
        "Enter_role": "Ingresa el rol",
        "Enter_Field_Label": "Ingresa la etiqueta del campo",
        "Enter_Placeholder": "Ingresa el marcador de posición",
        "field_label": "Etiqueta del campo",
        "placeholder": "Marcador de posición",
        "Enter_Number": "Ingresa número"
    },
    "DuplicateTask": {
        "duplicate_task_name": "Nombre de tarea duplicado",
        "what_do_you_copy": "¿Qué deseas copiar?",
        "everything": "Todo",
        "no_assignee": "Sin asignar",
        "no_watcher": "Sin observador",
        "move_task": "Mover tarea",
        "mearge_task_into": "Fusionar tarea en"
    },
    "Converttolist": {
        "are_you_sure_convert": "¿Estás seguro de que deseas convertir esta tarea en una lista?",
        "important": "Importante",
        "you_will_lose": "Perderás todos los comentarios en hilo. Esta acción no se puede deshacer.",
        "convert_to_list": "Convertir en lista"
    },
    "Billing": {
        "billing_details": "Detalles de facturación",
        "plan_details": "Detalles del plan",
        "next_msg": "El siguiente monto a pagar es",
        "due_on": "Vence el",
        "upgrade_plan": "Actualizar plan",
        "cancel_subscription": "Cancelar suscripción",
        "reactivate_subscription": "Reactivar suscripción",
        "biling_info": "Información de facturación",
        "update_billing_info": "Actualizar información de facturación",
        "contact_support": "Contactar soporte",
        "for_help_msg": "Para ayuda y soporte con tus preguntas de facturación, contacta a nuestro equipo de soporte y estarán encantados de ayudarte.",
        "payment_methods": "Métodos de pago",
        "update_payment_method": "Actualizar método de pago",
        "add_payment_method": "Agregar método de pago",
        "ending_in": "terminando en",
        "payment_method_update": "Actualización de método de pago exitosa.",
        "waiting_msg": "La actualización de tu método de pago tomará efecto en tu próxima factura y se usará para todos los pagos futuros.",
        "error_updating": "Actualización de método de pago no exitosa. Encontramos un problema al actualizar tu método de pago. Por favor, inténtalo de nuevo o contacta soporte para asistencia.",
        "card_expires": "La tarjeta expira en",
        "billing_address": "Dirección de facturación",
        "subscription_plan": "Plan de suscripción",
        "next_renew_date": "Próxima fecha de renovación",
        "storage_use": "Uso de almacenamiento",
        "address": "Dirección",
        "address_line": "Línea de dirección",
        "zip_code": "Código postal",
        "zip": "Código postal",
        "Save_&_Continue": "Guardar y continuar",
        "billing_history": "Historial de facturación",
        "Invoices": "Facturas",
        "credit_notes": "Notas de crédito",
        "download": "Descargar",
        "id": "Id",
        "type": "Tipo",
        "date": "Fecha",
        "description": "Descripción",
        "no_of_users": "N° de usuarios",
        "amount": "Monto",
        "status": "Estado",
        "pay_now": "Pagar ahora",
        "cancelling_subscription_message": "Cancelar la suscripción significa que tu suscripción finaliza el",
        "reactivate_anytime": "¡Reactiva en cualquier momento antes de esa fecha!",
        "reactivate_confirmation": "¿Estás seguro de que deseas reactivar la suscripción? Al seleccionar 'Sí', reactivarás y reanudarás tu programa de facturación.",
        "amounting_to": "por un monto de",
        "insufficient_funds": "Fondos insuficientes",
        "payment_successful": "Pago exitoso.",
        "payment_successful_details": "¡Pago exitoso! Tu factura está pagada. Por favor, espera de 2 a 3 minutos para que los cambios surtan efecto en todas partes, asegurando que puedas disfrutar completamente de las funciones y mejoras ampliadas.",
        "payment_unsuccessful": "Pago no exitoso. Encontramos un problema al actualizar tu plan. Por favor, inténtalo de nuevo o contacta soporte para asistencia.",
        "plan_upgrade_unsuccessful": "Actualización de plan no exitosa. Encontramos un problema al actualizar tu plan. Asegúrate de que la tarjeta tenga saldo suficiente.",
        "proceed_with_payment": "¿Deseas proceder con el pago de la factura número?",
        "attention_needed": "¡Necesitamos tu atención!",
        "avoid_service_disruption": "para evitar la interrupción del servicio",
        "subscription_renewal_failed": "La renovación automática de la suscripción falló debido a",
        "update_payment_method_please": "Por favor, actualiza tu método de pago",
        "click_here_for_update_payment_method": "Haz clic aquí para actualizar el método de pago",
        "credit_balance": "Saldo de crédito",
        "this_balance_will_be_used_for_a_future_payment": "Este saldo se utilizará para un pago futuro.",
        "paymnet_failed_subscription_canceled": "Queremos informarle que su suscripción anterior ha sido cancelada. Su cuenta ha sido transferida a nuestra suscripción predeterminada, que tiene algunas funciones deshabilitadas. Para habilitar estas funciones, actualice su plan.",
        "promotional_credit_balance": "Crédito promocional",
        "balance": "Saldo",
        "created_on": "Creado el",
        "no_promotional_found": "No se encontró historial de crédito promocional"
    },
    "Tour": {
        "tour_completed": "Tour Completo",
        "do_you_have_any": "¿Tienes alguna consulta? Te animamos a explorar nuestros completos tutoriales en video de BRAND_NAME para comenzar y aprovechar al máximo tu experiencia.",
        "watch_video": "Ver Video",
        "have_brief_tour_alianhub": "¿Hacer un breve recorrido por BRAND_NAME?",
        "have_brief_tour_alianhub_view": "¿Hacer un breve recorrido por las vistas de BRAND_NAME?",
        "have_brief_tour_alianhub_left_side": "¿Hacer un breve recorrido por la lista de proyectos?",
        "look_how_to_create": "Mira cómo crear proyectos, gestionar tareas, ver informes de hoja de tiempo, ingresar a un chat, ver menciones y notificaciones, y más.",
        "lets_start": "Comencemos",
        "no_thanks": "No, gracias",
        "have_brief_task": "¿Hacer un breve recorrido por Tareas?",
        "have_brief_tour_project": "¿Hacer un breve recorrido por el proyecto?",
        "look_how_to_create_task": "Mira cómo crear tareas, gestionar tareas, ver tareas según el grupo de estado y más.",
        "look_how_to_create_project": "Mira cómo crear proyectos, gestionar proyectos, ver tareas según el grupo de estado y más.",
        "project_creation_description": "Los proyectos se pueden crear, asignar y rastrear fácilmente, con una visibilidad clara de las responsabilidades para los miembros del equipo. Esto promueve una mejor organización, lo que lleva a una mayor eficiencia y productividad. Haz clic aquí para iniciar un nuevo proyecto.",
        "enter_project_name": "Por favor ingresa un nombre breve para tu proyecto.",
        "enter_project_key": "Por favor ingresa una clave breve para tu proyecto.",
        "add_project_category": "Por favor agrega una categoría para tu proyecto.",
        "enter_project_duedate": "Por favor ingresa una fecha de vencimiento para tu proyecto.",
        "add_project_lead_assignee": "Por favor agrega un responsable líder para tu proyecto.",
        "create_project_from_template": "Esta opción te permite crear rápidamente un nuevo proyecto usando una plantilla existente, que viene con datos y configuraciones preconfigurados, permitiéndote replicar la misma configuración del proyecto fácilmente.",
        "customize_project_section": "Esta opción te permite personalizar completamente tu proyecto configurando diversos elementos como estados, tipos, aplicaciones y más, adaptados a tus necesidades específicas.",
        "task_type_templates_list_text": "Lista de Plantillas de Tipos de Tareas",
        "task_type_templates_description_text": "Esta sección muestra las plantillas de tipos de tareas disponibles. Selecciona la que más se adapte a tus necesidades.",
        "create_new_task_type_template_text": "Crear Nueva Plantilla de Tipo de Tarea",
        "create_new_task_type_template_description_text": "Haz clic en el botón + para agregar una nueva plantilla de tipo de tarea, que luego podrás usar para tus tareas.",
        "view_template_task_types_text": "Ver Tipos de Tareas de Plantilla",
        "view_template_task_types_description_text": "Aquí puedes ver los tipos de tareas vinculados a la plantilla seleccionada. Puedes modificar o agregar nuevos tipos de tareas según tus necesidades.",
        "add_new_task_type_text": "Agregar Nuevo Tipo de Tarea",
        "add_new_task_type_description_text": "Haz clic en el botón 'Agregar Tipo de Tarea' para incluir nuevos tipos de tareas en la plantilla seleccionada.",
        "save_project_as_template_text": "Guardar Proyecto como Plantilla",
        "save_project_as_template_description_text": "Haz clic en 'Guardar como Plantilla' para almacenar la configuración actual para su uso en proyectos futuros.",
        "initiate_new_project_text": "Iniciar Nuevo Proyecto",
        "initiate_new_project_description_text": "Haz clic aquí para iniciar un nuevo proyecto.",
        "add_new_task_text": "Agregar Nueva Tarea",
        "input_task_name_text": "Ingresar Nombre de la Tarea",
        "choose_task_status_text": "Elegir Estado de la Tarea",
        "assign_task_text": "Asignar Tarea",
        "set_task_deadline_text": "Establecer Fecha de Vencimiento de la Tarea",
        "define_task_priority_text": "Definir Prioridad de la Tarea",
        "view_task_list_text": "Ver Lista de Tareas",
        "task_information_text": "Información de la Tarea",
        "quick_task_menu_text": "Menú Rápido de Tareas",
        "task_actions_text": "Acciones de Tareas",
        "subtask_toggle_text": "Alternar Subtarea",
        "task_tour_complete_text": "Recorrido por la Tarea Completo",
        "create_new_task_description_text": "Crea una nueva tarea haciendo clic en el botón '+ Nueva Tarea'.",
        "input_task_name_description_text": "Ingresa el nombre de la tarea en el campo de entrada proporcionado.",
        "choose_task_status_description_text": "Selecciona el tipo de tarea apropiado según tus necesidades.",
        "assign_task_description_text": "Selecciona a la persona a quien se asignará la tarea.",
        "set_task_deadline_description_text": "Elige una fecha de vencimiento para la tarea.",
        "define_task_priority_description_text": "Elige el nivel de prioridad de la tarea.",
        "view_task_list_description_text": "Esta es una lista de tareas, mostrando sus detalles y agrupadas por estado.",
        "task_information_description_text": "Aquí están los detalles de la tarea seleccionada.",
        "quick_task_menu_description_text": "Haciendo clic en el ícono se abrirá un menú desplegable con opciones de operación de tareas.",
        "task_actions_description_text": "Selecciona una acción de la lista de operaciones disponibles de tareas.",
        "subtask_toggle_description_text": "Aquí hay un interruptor para mostrar la lista de subtareas.",
        "task_tour_complete_description_text": "¡El recorrido ha concluido! Comienza a explorar las muchas posibilidades por delante.",
        "search_and_filter_projects_text": "Buscar y Filtrar Proyectos",
        "search_projects_text": "Buscar Proyectos",
        "search_options_for_projects_text": "Opciones de Búsqueda para Proyectos",
        "search_projects_by_name_text": "Buscar Proyectos por Nombre",
        "advanced_project_search_text": "Búsqueda Avanzada de Proyectos",
        "filter_projects_by_favorites_text": "Filtrar Proyectos por Favoritos",
        "project_settings_text": "Configuración del Proyecto",
        "project_list_text": "Lista de Proyectos",
        "end_of_project_view_tour_text": "Fin del Recorrido de Vista del Proyecto",
        "search_and_filter_projects_description_text": "Busca y filtra proyectos según tus criterios aquí.",
        "enter_search_keywords_text": "Ingresa palabras clave de búsqueda para encontrar proyectos específicos.",
        "search_filter_dropdown_description_text": "Haz clic en el ícono para abrir un menú desplegable con filtros de búsqueda.",
        "toggle_search_options_description_text": "Alterna entre las opciones para buscar por proyecto, sprint o carpeta mientras escribes.",
        "advanced_search_icon_description_text": "Haz clic en el ícono para realizar una búsqueda avanzada.",
        "filter_by_favorites_description_text": "Haz clic en el ícono de estrella para priorizar tus proyectos favoritos en la parte superior de la lista.",
        "project_settings_icon_description_text": "Haz clic en el ícono de configuración para cambiar entre las opciones de proyectos archivados o no archivados.",
        "view_project_list_description_text": "Aquí puedes ver tu lista de proyectos.",
        "end_of_project_view_tour_description_text": "El recorrido ha finalizado.",
        "create_assign_prioritize_monitor_projects_text": "Crea, asigna, prioriza y monitorea proyectos de manera fácil. Los miembros del equipo pueden ver claramente sus tareas, mantenerse organizados y mejorar la eficiencia y productividad. Haz clic aquí para iniciar un Nuevo Proyecto.",
        "track_users_time_sheet_reports_text": "Realiza un seguimiento del tiempo de los usuarios con varios informes de hoja de tiempo como la Hoja de Tiempo de Usuario, Hoja de Tiempo de Proyecto, Hoja de Tiempo de Carga de Trabajo y Hoja de Tiempo del Rastreador. Haz clic aquí para explorar los Informes de Hoja de Tiempo.",
        "user_time_sheet_description_text": "La hoja de tiempo del usuario te permite monitorear las horas registradas por cada usuario según tu rol de usuario.",
        "project_time_sheet_description_text": "Realiza un seguimiento de las horas registradas para cada proyecto en la hoja de tiempo del proyecto según tu rol de usuario.",
        "workload_time_sheet_description_text": "Similar a la hoja de tiempo de usuario, la hoja de tiempo de carga de trabajo también incluye detalles sobre la carga de trabajo del usuario, horas totales y horas estimadas.",
        "tracker_sheet_description_text": "La hoja del rastreador muestra el tiempo registrado mediante el rastreador de tiempo, junto con capturas de pantalla y el tiempo total registrado.",
        "view_companies_switch_text": "Ver todas las empresas con las que estás asociado y cambiar entre ellas seleccionando una.",
        "engage_team_real_time_text": "Interactúa con los miembros del equipo en tiempo real para tomar decisiones rápidas. Crea canales y comparte información mediante archivos adjuntos, mensajes de voz y texto.",
        "real_time_notifications_text": "Mantente actualizado con notificaciones en tiempo real sobre actividades de proyectos y tareas, incluidas asignaciones de tareas, cambios de estado, comentarios y plazos.",
        "address_specific_individuals_text": "Dirígete directamente a personas específicas dentro del sistema de gestión de proyectos. Ve las menciones relacionadas con tareas, proyectos o discusiones.",
        "access_personal_information_text": "Accede a tu información personal, junto con la configuración relacionada con empresas, proyectos, usuarios y seguridad, según tu rol de usuario.",
        "project_views_list_text": "Lista de Vistas del Proyecto",
        "add_new_project_view_text": "Agregar Nueva Vista de Proyecto",
        "manage_project_views_text": "Gestionar Vistas de Proyecto",
        "project_files_text": "Archivos del Proyecto",
        "project_audio_files_text": "Archivos de Audio del Proyecto",
        "add_project_watcher_text": "Agregar Observador al Proyecto",
        "project_operation_list_text": "Lista de Operaciones del Proyecto",
        "advanced_task_filter_text": "Filtro Avanzado de Tareas",
        "search_tasks_text": "Buscar Tareas",
        "search_options_menu_text": "Menú de Opciones de Búsqueda",
        "search_criteria_text": "Criterios de Búsqueda",
        "project_views_list_description_text": "Una lista de las vistas disponibles del proyecto.",
        "add_new_project_view_description_text": "Crea una nueva vista aquí.",
        "manage_project_views_description_text": "Aquí puedes agregar o fijar vistas a un proyecto. Haz clic en 'Agregar Vista' para agregar o selecciona 'Fijar Vista' para fijar una vista.",
        "project_files_description_text": "Accede a todos los archivos y enlaces del proyecto haciendo clic en el ícono.",
        "project_audio_files_description_text": "Haz clic en el ícono para ver todos los archivos de audio relacionados con el proyecto.",
        "add_project_watcher_description_text": "Gestiona la configuración de los observadores del proyecto.",
        "project_operation_list_description_text": "Realiza diversas operaciones del proyecto desde aquí.",
        "advanced_task_filter_description_text": "Haz clic en el ícono para realizar una búsqueda avanzada.",
        "search_tasks_description_text": "Ingresa palabras clave relevantes para buscar tareas específicas.",
        "search_options_menu_description_text": "Haz clic en el ícono para abrir un menú desplegable con diferentes opciones de búsqueda.",
        "search_criteria_description_text": "Elige entre el nombre de tarea, clave de tarea o descripción para refinar tu búsqueda mientras escribes.",
        "select_operation_description_text": "Selecciona una operación de la lista para realizar la acción deseada en el proyecto."
    },
    "TaskStatus": {
        "To_Do": "Por Hacer"
    },
    "AI": {
        "generate": "Generar",
        "ai_button": "Escribir con IA",
        "ai_title": "Pedirle a la IA que encuentre o cree algo",
        "write_with_ai": "Escribir con IA",
        "suggest_tasks": "Sugerir tareas",
        "suggest_subtasks": "Sugerir subtareas",
        "ai_sidebar_placeholder": "¿Sobre qué te gustaría que escribiera la IA?",
        "ai_chat_placeholder": "Dile a la IA qué hacer a continuación",
        "ai_available_on_paid_plans_upgrade_now": "La IA solo está disponible para su compra en nuestros planes pagos. ¡Actualiza y agrega IA ahora!",
        "please_upgrade_plan_to_use_ai": "Por favor, actualiza tu plan para usar la IA.",
        "read_less": "Leer menos",
        "read_more": "Leer más",
        "to_unlock_ai": "Para desbloquear la IA",
        "copy": "Copiar",
        "generating_results": "Generando resultados",
        "hub_ai": "HubAi",
        "regenerate": "Regenerar",
        "title": "Título",
        "error_occurred_engine_issue": "Ocurrió un error. El motor que solicitaste no existe o hubo otro problema al procesar tu solicitud",
        "ai_not_integrated": "La IA no está integrada en tu sistema",
        "limit_reached": "Has alcanzado tu límite"
    },
    "Toast": {
        "Your_card_is_expired": "Tu tarjeta ha caducado.",
        "Password_set_new_has_been_successfully": "La nueva contraseña se ha establecido con éxito.",
        "task_created_successfully": "Tarea creada con éxito",
        "please_remove_the_advanced_filter_to_view_newly_created_projects": ", Por favor, elimina el filtro avanzado para ver los proyectos recién creados.",
        "create_task_plan_limit_message": "Actualiza tu plan. Has alcanzado el límite para crear tareas en el sprint TASK_SPRINT.",
        "something_went_wrong": "Algo salió mal.",
        "file_size_is_larger_than_maxFileSize": "El tamaño del archivo es mayor que el tamaño máximo permitido",
        "Select_image_only_and_image_file_format_should_be_FILE_FORMATS": "Selecciona solo imagen y el formato de archivo de imagen debe ser FILE_FORMATS",
        "Select_file_only_image_and_image_file_format_should_be_FILE_FORMATS": "Selecciona solo archivo de imagen y el formato de archivo de imagen debe ser FILE_FORMATS",
        "Multiple_files_not_allowed": "No se permiten varios archivos.",
        "Please_select_valid_file": "Por favor selecciona un archivo válido.",
        "require_image_format_message": "El formato de archivo no es compatible o no se ha agregado en la configuración de la empresa. Puede agregar el formato de archivo en Configuración.",
        "You_have_to_add_extension_in_setting": "Debes agregar la extensión en la configuración.",
        "Something_went_wrong_Please_try_again": "Algo salió mal. Por favor, intenta nuevamente.",
        "Company_is_disable": "La empresa está deshabilitada",
        "advance_search_feature_upgrade_message": "La función de búsqueda avanzada no está disponible en tu plan actual. Para desbloquear la búsqueda avanzada, actualiza tu plan.",
        "Access_Denied": "Acceso denegado",
        "notification_permission": "Para recibir notificaciones, por favor permite el permiso de notificación en la configuración del sitio y recarga la página nuevamente.",
        "Link_is_Copied_to_clipboard": "El enlace ha sido copiado al portapapeles",
        "Task_Key_is_Copied_to_clipboard": "La clave de la tarea ha sido copiada al portapapeles",
        "At_least_one_field_is_required": "Se requiere al menos un campo.",
        "Task_name_updated_successfully": "El nombre de la tarea se actualizó con éxito",
        "Watcher_added_successfully": "Observador agregado con éxito",
        "Watcher_removed_successfully": "Observador eliminado con éxito",
        "Nothing_to_update": "Nada que actualizar",
        "Sprint created successfully": "Sprint creado con éxito",
        "Sprint restored successfully": "Sprint restaurado con éxito",
        "Sprint closed successfully": "Sprint cerrado con éxito",
        "Sprint archived successfully": "Sprint archivado con éxito",
        "Sprint deleted successfully": "Sprint eliminado con éxito",
        "Upgrade_your_plan_you_have_reached_the_limit_for_creating_sprints": "Actualiza tu plan. Has alcanzado el límite para crear sprints.",
        "Folder created successfully": "Carpeta creada con éxito",
        "Folder updated successfully": "Carpeta actualizada con éxito",
        "Folde restored successfully": "Carpeta restaurada con éxito",
        "Folder closed successfully": "Carpeta cerrada con éxito",
        "Folder archived successfully": "Carpeta archivada con éxito",
        "Folder deleted successfully": "Carpeta eliminada con éxito",
        "Status_changed_successfully": "Estado cambiado con éxito",
        "Due_date_updated_successfully": "Fecha de vencimiento actualizada con éxito",
        "Due_date_not_updated": "Fecha de vencimiento no actualizada",
        "Assignee changed_ uccessfully": "Asignado cambiado con éxito",
        "Assignee added successfully": "Asignado agregado con éxito",
        "Assignee removed successfully": "Asignado eliminado con éxito",
        "Assignee not updated": "Asignado no actualizado",
        "Task_updated_successfully": "Tarea actualizada con éxito",
        "Task_restored_successfully": "Tarea restaurada con éxito",
        "Task_archived_successfully": "Tarea archivada con éxito",
        "Task_deleted_successfully": "Tarea eliminada con éxito",
        "Tag_Deleted_successfully": "Etiqueta eliminada con éxito",
        "Log_time_added_successfully": "Tiempo registrado con éxito.",
        "Filter_saved_successfully": "Filtro guardado con éxito.",
        "Filter_update_successfully": "Filtro actualizado con éxito.",
        "Filter_deleted_successfully": "Filtro eliminado con éxito.",
        "Checklist_creted_succesfully.": "Lista de verificación creada con éxito.",
        "Please_select_checklist": "Por favor selecciona la lista de verificación.",
        "already_exists": "EXIST_VALUE ya existe",
        "Converted_sucessfully": "Convertido con éxito",
        "create_task_limit_in_sprint_upgrade_task_message": "Actualiza tu plan. Has alcanzado el límite para crear tareas en el sprint SELECTED_SPRINT_DATA.",
        "Please_Select_Task_Type": "Por favor selecciona el tipo de tarea",
        "Please_Select_Task": "Por favor selecciona tarea",
        "Task_moved_sucessfully": "Tarea movida con éxito",
        "Task_not_moved": "Tarea no movida",
        "Task_duplicate_sucessfully": "Tarea duplicada con éxito",
        "Task_not_duplicated": "Tarea no duplicada",
        "Convert_in_to_task_sucessfully": "Convertido en tarea con éxito",
        "Company_name_already_exists": "El nombre de la empresa ya existe",
        "Company_has_been_created_Successfully": "La empresa ha sido creada con éxito.",
        "Custom_field_updated_successfully": "Campo personalizado actualizado con éxito",
        "No_assignee_found": "No se encontró asignado",
        "No_due_date_found": "No se encontró fecha de vencimiento",
        "No_self_assignee_found": "No se encontró auto-asignado",
        "Estimated_time_updated_successfully": "Tiempo estimado actualizado con éxito",
        "Description_updated_successfully": "Descripción actualizada con éxito",
        "Description_not_updated": "Descripción no actualizada",
        "Copied": "¡Copiado!",
        "User_removed_successfully": "Usuario eliminado con éxito",
        "Invitation_cancelled_successfully": "Invitación cancelada con éxito",
        "User_role_changed_successfully": "Rol de usuario cambiado con éxito",
        "User_designation_changed_successfully": "Designación de usuario cambiada con éxito.",
        "Please_upgrade_your_plan_to_use_Time_Tracker": "Por favor, actualiza tu plan para usar el Rastreador de tiempo.",
        "Request_remove_successfully": "Solicitud eliminada con éxito",
        "Upgrade_Your_Plan": "Actualiza tu plan",
        "Updated_successfully": "Actualizado con éxito",
        "Deleted_successfully": "Eliminado con éxito",
        "View_Pinned": "Ver fijado",
        "View_Unpinned": "Ver no fijado",
        "View_Already_Added": "Ver ya agregado",
        "Company_details_saved_successfully": "Detalles de la empresa guardados con éxito.",
        "Currency_added_successfully": "Moneda agregada con éxito",
        "Currency_removed_successfully": "Moneda eliminada con éxito",
        "File_extension_remove_successfully": "Extensión de archivo FILE_EXTENSION eliminada con éxito",
        "File_extension_update_successfully": "Extensión de archivo actualizada con éxito.",
        "Status_updated_successfully": "Estado actualizado con éxito",
        "Project_milestone_status_Deleted_successfully": "Estado de hito del proyecto eliminado con éxito.",
        "Milestone_weekly_range_updated_successfully": "Rango semanal de hito actualizado con éxito.",
        "Image_dimensions_should_not_exceed_ImageDimensions_pixels": "Las dimensiones de la imagen no deben exceder los píxeles de ImageDimensions.",
        "error_in_uploading_image_please_try_it_again": "Error al cargar la imagen. Por favor, inténtalo de nuevo",
        "Task_priority_updated_successfully": "Prioridad de la tarea actualizada con éxito.",
        "Task_priority_Remove_successfully": "Prioridad de la tarea eliminada con éxito.",
        "Priority_updated_successfully": "Prioridad actualizada con éxito",
        "Priority_not_updated": "Prioridad no actualizada",
        "error_in_deleting_priority_please_try_it_again": "Error al eliminar la prioridad. Por favor, intenta de nuevo",
        "Field_Enable_Successfully": "Campo habilitado con éxito",
        "Field_Disable_Successfully": "Campo deshabilitado con éxito",
        "Field_Added_Successfully": "Campo agregado con éxito",
        "Field_Updated_Successfully": "Campo actualizado con éxito",
        "Added_to_favourite": "Añadido a favoritos",
        "Removed_from_favourite": "Eliminado de favoritos",
        "Tag_Created_successfully": "Etiqueta creada con éxito",
        "Queue list added successfully": "Lista de cola agregada con éxito",
        "Queue list removed successfully": "Lista de cola eliminada con éxito",
        "Queue list not updated": "Lista de cola no actualizada",
        "Attachments_uploaded_successfully": "Archivos adjuntos cargados con éxito",
        "Attachment_removed_successfully": "Archivo adjunto eliminado con éxito",
        "Attachment_not_removed": "Archivo adjunto no eliminado",
        "Please_try_again": "Por favor, intenta de nuevo",
        "Task_name_copied": "Nombre de la tarea copiado",
        "Status_already_exists": "El estado ya existe",
        "Status_added_sucessfully": "Estado agregado con éxito",
        "Task_Type_already_exists": "El tipo de tarea ya existe",
        "Task_Type_added_sucessfully": "Tipo de tarea agregado con éxito",
        "Image_size_must_be_less_than_ImageDimensions_pixels": "El tamaño de la imagen debe ser menor que ImageDimensions píxeles.",
        "Data_deleted_successfully": "Datos eliminados con éxito.",
        "Category_created_successfully": "Categoría creada con éxito",
        "Please_select_an_image_file": "Por favor selecciona un archivo de imagen",
        "Channel_created_successfully": "Canal creado con éxito",
        "Folder_not_found": "Carpeta no encontrada",
        "Template_&_Project_data_has_been_added_successfully": "Datos de plantilla y proyecto agregados con éxito.",
        "Project_data_has_been_added_successfully": "Datos del proyecto agregados con éxito{filterMessage}",
        "Error_in_creating_project": "Error al crear el proyecto",
        "Milestone_deleted_successfully": "Hito eliminado con éxito",
        "Error_in_deleting_milestone": "Error al eliminar el hito",
        "Milestone_added_successfully": "Hito agregado con éxito",
        "Error_in_adding_milestone": "Error al agregar el hito",
        "Milestone_update_successfully": "Hito actualizado con éxito",
        "Error_in_updating_milestone": "Error al actualizar el hito",
        "Milestone_status_update_successfully": "Estado del hito actualizado con éxito",
        "Error_in_updating_milestone_status": "Error al actualizar el estado del hito",
        "Milestone_refund_amount_update_successfully": "Monto de reembolso del hito actualizado con éxito",
        "Error_in_updating_milestone_refund_amount": "Error al actualizar el monto de reembolso del hito",
        "The_project_not_found": "Proyecto no encontrado.",
        "The_project_is_archived": "El proyecto está archivado.",
        "Start_date_of_project_should_be_smaller_than_current_date": "La fecha de inicio del proyecto debe ser anterior a la fecha actual",
        "All_the_range_is_included_in_milestone": "Todo el rango está incluido en el hito",
        "Please_enter_start_date_of_project": "Por favor, ingrese la fecha de inicio del proyecto",
        "Project_name_updated_successfully": "Nombre del proyecto actualizado con éxito",
        "Project restored successfully": "Proyecto restaurado con éxito",
        "Project closed successfully": "Proyecto cerrado con éxito",
        "Project archived successfully": "Proyecto archivado con éxito",
        "Project deleted successfully": "Proyecto eliminado con éxito",
        "Enter_valid_project_source": "Ingrese una fuente de proyecto válida",
        "Please_select_sub_task": "Por favor, seleccione una subtarea.",
        "Status_not_updated": "Estado no actualizado",
        "Start_date_updated_successfully": "Fecha de inicio actualizada con éxito",
        "Start_date_not_updated": "Fecha de inicio no actualizada",
        "Task_converted_sucessfully": "Tarea convertida con éxito",
        "Task_merged_sucessfully": "Tarea fusionada con éxito",
        "Can_not_create_template_name_Custom": "No se puede crear el nombre de plantilla 'Custom'",
        "Template_name_updated_successfully": "Nombre de plantilla actualizado con éxito.",
        "Template_has_been_created_Successfully": "Plantilla creada con éxito.",
        "Template_deleted_successfull": "Plantilla eliminada con éxito.",
        "Template_has_been_deleted_successfully": "Plantilla eliminada con éxito.",
        "Storage_exceeded_Upgrade_your_plan": "Almacenamiento excedido. Actualice su plan",
        "max_filesize_messages": "El tamaño máximo de archivo es de FILE_SIZE MB.",
        "Password_reset_email_has_been_sent_successfully": "Correo electrónico de restablecimiento de contraseña enviado con éxito",
        "Invalid_username_or_password": "Nombre de usuario o contraseña inválidos.",
        "Email_Not_Verified": "Correo electrónico no verificado.",
        "Verification_mail_has_been_send_successfully": "Correo de verificación enviado con éxito",
        "Invalid_url": "URL inválida",
        "User_already_registered": "Usuario ya registrado.",
        "User_has_been_registered_successfully": "Usuario registrado con éxito.",
        "The_email_address_is_already_in_use": "La dirección de correo electrónico ya está en uso",
        "User_has_been_registered_successfully_Please_verify_your_email_to_continue": "Usuario registrado con éxito, por favor verifique su correo electrónico para continuar.",
        "Password_reset_has_been_successfully": "Restablecimiento de contraseña realizado con éxito",
        "Your_email_has_been_verify_successfully": "Su correo electrónico ha sido verificado con éxito",
        "Invitation_accepted_successfully": "Invitación aceptada con éxito",
        "Only_product_owner_can_create_a_company": "Solo el propietario del producto puede crear una empresa",
        "Company_name_must_be_unique": "El nombre de la empresa debe ser único.",
        "Subscription_cancel_succesfully_Please_allow_2_to_3_minutes_for_the_changes_to_take_effect_everywhere": "Suscripción cancelada con éxito. Por favor, espere de 2 a 3 minutos para que los cambios surtan efecto en todas partes.",
        "Subscription_reactivate_succesfully_Please_allow_2_to_3_minutes_for_the_changes_to_take_effect_everywhere": "Suscripción reactivada con éxito. Por favor, espere de 2 a 3 minutos para que los cambios surtan efecto en todas partes.",
        "View_name_is_required": "Se requiere el nombre de la vista",
        "name_should_be_at_least_3_characters_long": "El nombre debe tener al menos 3 caracteres",
        "View_name_already_exists": "El nombre de la vista ya existe",
        "View_added_successfully": "Vista añadida con éxito",
        "View_Deleted_Successfully": "Vista eliminada con éxito",
        "Link_copied_to_clipboard_successfully": "Enlace copiado al portapapeles con éxito",
        "Project_avatar_updated_successfully": "Avatar del proyecto actualizado con éxito",
        "Message pinned successfully": "Mensaje fijado con éxito",
        "Message unpinned successfully": "Mensaje desanclado con éxito",
        "Message_copied": "Mensaje copiado",
        "Item_cannot_be_empty": "El ítem no puede estar vacío",
        "Maximum_MAX_CHAR_characters_are_allowed": "Se permiten un máximo de MAX_CHAR caracteres",
        "Item_added_to_checklist": "Ítem añadido a la lista de verificación",
        "Maximum_10_files_can_be_uploaded_at_once": "Se pueden cargar un máximo de 10 archivos a la vez",
        "file_type_is_not_supported": "¡El tipo de archivo no es compatible!",
        "ERROR_in_file_upload": "ERROR en la carga del archivo",
        "file_size_is_larger_than_FILE_SIZE_mb": "¡El tamaño del archivo es mayor que FILE_SIZE MB!",
        "Mark_as_favorite_successfully": "Marcado como favorito con éxito",
        "Start_and_Due_date_updated_successfully": "Fecha de inicio y fecha de vencimiento actualizadas con éxito",
        "Start_and_Due_date_not_updated": "Fecha de inicio y fecha de vencimiento no actualizadas",
        "Attchments_deleted_successfully": "Archivos adjuntos eliminados con éxito",
        "Designation_is_required": "Se requiere una designación",
        "Designation_already_exists": "La designación ya existe",
        "Designation_added_successfully": "Designación añadida con éxito",
        "Designation_updated_successfully": "Designación actualizada con éxito",
        "Role_is_required": "Se requiere un rol",
        "Role_already_exists": "El rol ya existe",
        "Role_added_successfully": "Rol añadido con éxito",
        "Role_updated_successfully": "Rol actualizado con éxito",
        "Please_provide_an_email_id": "Por favor, proporcione una dirección de correo electrónico",
        "Please_provide_a_designation": "Por favor, proporcione una designación",
        "Please_provide_a_role": "Por favor, proporcione un rol",
        "Designation_deleted_successfully": "Designación eliminada con éxito",
        "The_role_is_already_in_use_so_it_can't_be_deleted": "El rol ya está en uso, por lo que no se puede eliminar.",
        "Role_deleted_successfully": "Rol eliminado con éxito",
        "Language_not_updated": "¡Idioma no actualizado!",
        "Profile_updated_successfully": "Perfil actualizado con éxito.",
        "Notification_Settings_Update_successfully": "Configuración de notificaciones actualizada con éxito",
        "Permission_updated_successfully": "Permiso actualizado con éxito",
        "Per_User_Generate_Limit_value_is_not_valid": "El valor de límite de generación por usuario no es válido",
        "Team_name_is_required": "Se requiere un nombre de equipo",
        "Minimum_3_character_required": "Se requieren al menos 3 caracteres",
        "Team_name_already_exist": "El nombre del equipo ya existe",
        "Template_has_been_added_successfully": "Plantilla añadida con éxito.",
        "Billing_details_has_been_updated_successfully": "Detalles de facturación actualizados con éxito",
        "Billing_details_not_updated": "Detalles de facturación no actualizados",
        "Invalid_Card_Details_Please_check_and_try_again": "Detalles de tarjeta inválidos. Por favor, verifique e intente de nuevo.",
        "Expired_Card_Please_check_and_try_again": "Tarjeta caducada. Por favor, verifique e intente de nuevo.",
        "Invalid_card_verification_code_(CVC)_Please_check_and_try_again": "Código de verificación de tarjeta (CVC) inválido. Por favor, verifique e intente de nuevo.",
        "You_have_cancel_your_current_subscription_at_term_end_please_reactivate_subscription_and_try_again": "Ha cancelado su suscripción actual al final del plazo. Por favor, reactive la suscripción e intente de nuevo.",
        "Plan_not_purchased_Please_try_again": "Plan no adquirido. Por favor, intente de nuevo.",
        "Please_fill_out_billing_details_first": "Por favor, complete primero los detalles de facturación.",
        "Please_check_your_credential": "Por favor, verifique sus credenciales.",
        "File_type_not_supported": "El tipo de archivo no es compatible",
        "Are_you_sure_to_delete_this_file": "¿Está seguro de que desea eliminar este archivo?",
        "Select_Project_Type": "Seleccione el tipo de proyecto",
        "Tracker_user_added_successfully": "Usuario de seguimiento añadido con éxito",
        "Tracker_user_removed_successfully": "Usuario de seguimiento eliminado con éxito",
        "queue_list_not_updated": "Lista de cola no actualizada.",
        "upgrade_plan_folder_limit_reached": "Actualice su plan. Ha alcanzado el límite para crear carpetas",
        "View_updated_successfully": "Vista actualizada con éxito",
        "The_designation_is_already_in_use_so_it_cant_be_deleted": "La designación ya está en uso, por lo que no se puede eliminar",
        "Sprint_already_exists": "Sprint ya existe",
        "Folder_already_exists": "La carpeta ya existe",
        "Sprint updated successfully": "Sprint actualizado con éxito",
        "Project_milestone_status_updated_successfully": "Estado de hito del proyecto actualizado con éxito.",
        "Invalid_email": "Tu correo electrónico no es válido. Por favor verifique e intente nuevamente",
        "Invalid_password": "Su contraseña no es válida. Por favor verifique e intente nuevamente",
        "Too_many_request": "Demasiadas solicitudes. Por favor inténtalo de nuevo más tarde",
        "Password_reset_link": "¡Correo electrónico de vencimiento de contraseña enviado con éxito! Por favor, revisa tu bandeja de entrada para proceder con el restablecimiento de tu contraseña.",
        "Project_milestone_status_added_successfully": "El estado del hito del proyecto se agregó correctamente.",
        "Please_select_start_end_date": "Por favor selecciona tanto la fecha de inicio como la de finalización",
        "Invitation_canceled": "Invitación cancelada: Ya no puedes usar este enlace",
        "Ai_limit_reached": "Tu límite diario ha sido alcanzado.",
        "You_have_reached_the_maximum_limit_of_guest_users": "Actualiza tu plan. Has alcanzado el límite máximo de usuarios invitados.",
        "Upgrade_for_import": "Actualiza tu plan para acceder a la funcionalidad de importación.",
        "Upgrade_for_export": "Actualiza tu plan para acceder a la funcionalidad de exportación.",
        "import_task_success": "Tus tareas se han importado con éxito.",
        "export_task_success": "Tareas exportadas con éxito.",
        "export_task_error": "No hay tareas para exportar.",
        "invalid_file_error": "Tipo de archivo no válido. Por favor, sube un archivo .csv.",
        "free_company_limit_reached": "Has alcanzado el límite máximo para la creación de empresas gratuitas.",
        "Import_users_successfully": "Usuarios importados con éxito.",
        "date_range": "Por favor, seleccione un rango de fechas antes de aplicar.",
        "Task_total_estimate_update_succesfull": "Actualización exitosa de la estimación total de la tarea"
    },
    "SecurityAndPermission": {
        "project": "Proyecto",
        "project_list": "Lista de Proyectos",
        "project_create": "Crear Proyecto",
        "project_name_edit": "Editar Nombre del Proyecto",
        "project_sprint_create": "Crear Sprint del Proyecto",
        "project_folder_create": "Crear Carpeta del Proyecto",
        "project_folder_name_edit": "Editar Nombre de la Carpeta del Proyecto",
        "project_sprint_name_edit": "Editar Nombre del Sprint del Proyecto",
        "project_details": "Detalles del Proyecto",
        "project_status_change": "Cambiar Estado del Proyecto",
        "project_assignee": "Asignado al Proyecto",
        "project_category": "Categoría del Proyecto",
        "project_source": "Fuente del Proyecto",
        "project_type": "Tipo de Proyecto",
        "project_currency": "Moneda del Proyecto",
        "project_amount": "Monto del Proyecto",
        "project_start_date": "Fecha de Inicio del Proyecto",
        "project_end_date": "Fecha de Fin del Proyecto",
        "project_due_date": "Fecha de Vencimiento del Proyecto",
        "project_close": "Cerrar Proyecto",
        "project_description": "Descripción del Proyecto",
        "project_checklist": "Lista de Verificación del Proyecto",
        "project_checklist_assign_remove": "Asignar/Quitar de la Lista de Verificación del Proyecto",
        "project_attachments": "Archivos Adjuntos del Proyecto",
        "project_milestone": "Hito del Proyecto",
        "task": "Tarea",
        "task_list": "Lista de Tareas",
        "task_create": "Crear Tarea",
        "sub_task_create": "Crear Subtarea",
        "task_name_edit": "Editar Nombre de la Tarea",
        "task_status": "Estado de la Tarea",
        "task_assignee": "Asignado a la Tarea",
        "task_priority": "Prioridad de la Tarea",
        "task_due_date": "Fecha de Vencimiento de la Tarea",
        "task_estimated_hours": "Horas Estimadas de la Tarea",
        "task_description": "Descripción de la Tarea",
        "task_checklist": "Lista de Verificación de la Tarea",
        "task_checklist_assign_remove": "Asignar/Quitar de la Lista de Verificación de la Tarea",
        "task_attachments": "Archivos Adjuntos de la Tarea",
        "show_tasks": "Mostrar Tareas",
        "task_custom_field": "Campo Personalizado",
        "settings": "Configuración de la Empresa",
        "settings_edit_company": "Editar Empresa",
        "settings_task_priority": "Prioridad de Tareas",
        "settings_file_extensions": "Extensiones de Archivos",
        "settings_project_milestone_status": "Estado del Hito del Proyecto",
        "settings_invite_member": "Invitar Miembro",
        "settings_member_list": "Lista de Miembros",
        "settings_create_team": "Crear Equipo",
        "settings_team_list": "Lista de Equipos",
        "settings_project_list": "Lista de Proyectos",
        "settings_security_permissions": "Seguridad y Permisos",
        "settings_role_management": "Gestión de Roles",
        "settings_designation": "Designación",
        "milestone_weekly_range": "Rango Semanal de Hitos",
        "settings_custom_field": "Campo Personalizado",
        "sheet_settings": "Configuración de Hojas",
        "user_timesheet": "Hoja de Tiempo del Usuario",
        "project_timesheet": "Hoja de Tiempo del Proyecto",
        "workload_timesheet": "Hoja de Tiempo de Carga de Trabajo",
        "milestone_report": "Informe de Hitos",
        "artificial_intelligence": "Inteligencia Artificial",
        "per_user_generate_limit": "Límite de Token por Usuario",
        "project_custom_field": "Campo Personalizado del Proyecto",
        "public_projects": "Lista de Proyectos Públicos",
        "tracker_timesheet": "Hoja de Tiempo de Seguimiento",
        "view_list": "Ver lista",
        "chat": "Charla",
        "project_delete": "Eliminar proyecto",
        "folder_archive": "Archivar carpeta",
        "folder_delete": "Eliminar carpeta",
        "folder_restore": "Restaurar carpeta",
        "sprint_type_change": "Cambio de tipo de sprint",
        "sprint_restore": "Restaurar sprint",
        "sprint_delete": "Eliminar sprint",
        "sprint_archive": "Archivar sprint",
        "chat_channel": "Crear canal de chat",
        "chat_category": "Crear categoría de chat",
        "one_to_one_chat": "Chat uno a uno",
        "task_tag": "Etiqueta de tarea",
        "task_start_date": "Fecha de inicio de la tarea",
        "task_activity_log": "Registro de actividad de la tarea",
        "task_convert_to_list": "Convertir tarea en lista",
        "task_convert_to_subtask": "Convertir tarea en subtarea",
        "task_duplicate": "Duplicar tarea",
        "task_merge": "Fusionar tarea",
        "task_move": "Mover tarea",
        "task_archive": "Archivar tarea",
        "task_delete": "Eliminar tarea",
        "task_comment": "Comentario de tarea",
        "task_details": "Detalle de la tarea",
        "queue_list": "Lista de espera",
        "advance_search": "Búsqueda avanzada",
        "list_view_column": "Columna de vista de lista",
        "task_type": "Tipo de tarea",
        "import_tasks": "Importar tareas",
        "export_tasks": "Exportar tareas",
        "convert_to_task": "Convertir en tarea"
    },
    "general": {
        "Continue": "Continuar",
        "New_Status": "Nuevo Estado",
        "Old_Status": "Estado Anterior",
        "Old_Task_Type": "Tipo de Tarea Anterior",
        "New_Task_Type": "Nuevo Tipo de Tarea",
        "New_Task_Assignee": "Nuevo Asignado de Tarea",
        "Old_Task_Assignee": "Asignado de Tarea Anterior",
        "New_Task_Watchers": "Nuevos Observadores de Tarea",
        "Old_Task_Watchers": "Observadores de Tarea Anteriores",
        "Select_Status": "Seleccionar Estado",
        "Select_Task_Type": "Seleccionar Tipo de Tarea",
        "No_Assignee": "Sin Asignado",
        "No_Watchers": "Sin Observadores",
        "Different_Statuses": "Estados Diferentes",
        "Please_Select_Status": "Por Favor Selecciona un Estado",
        "Tomorrow": "Mañana",
        "Yesterday": "Ayer",
        "Project": "Proyecto",
        "Team": "Equipo",
        "User": "Usuario",
        "Copy_Assignees": "Copiar Asignados",
        "Copy_Watchers": "Copiar Observadores",
        "apply": "Aplicar",
        "current_month": "Mes Actual",
        "current_week": "Semana Actual",
        "keyboard": "Teclado",
        "mouse": "Ratón",
        "Create": "Crear",
        "scroll_to_bottom": "Desplazar hasta el Final",
        "unassigned": "Sin Asignar",
        "entries": "entradas",
        "showing": "Mostrando",
        "page_not_found": "Vaya, página no encontrada",
        "page_not_found_description": "Lo sentimos mucho por la inconveniencia. Parece que estás intentando acceder a una página que ha sido eliminada o nunca existió.",
        "note": "Nota",
        "settings_change_no_effect": "El cambio de la configuración abajo no afectará los valores actuales del campo si no están vacíos",
        "advanced": "Avanzado",
        "general": "General",
        "limits": "Límites",
        "message_deleted": "Mensaje eliminado",
        "company_individual": "Nombre de la empresa/individuo",
        "enter_company_individual": "Ingrese el nombre de la empresa/individuo"
    },
    "monthName": {
        "jan": "Ene",
        "feb": "Feb",
        "mar": "Mar",
        "apr": "Abr",
        "may": "May",
        "jun": "Jun",
        "jul": "Jul",
        "aug": "Ago",
        "sep": "Sep",
        "oct": "Oct",
        "nov": "Nov",
        "dec": "Dic"
    },
    "timeLog": {
        "start_time_field_required": "El campo de hora de inicio es obligatorio",
        "end_time_field_required": "El campo de hora de fin es obligatorio",
        "select_valid_time_duration": "Por favor, selecciona una duración de tiempo válida"
    },
    "weekName": {
        "sun": "Dom",
        "mon": "Lun",
        "tue": "Mar",
        "wed": "Mié",
        "thu": "Jue",
        "fri": "Vie",
        "sat": "Sáb",
        "fridays": "Viernes",
        "mondays": "Lunes",
        "saturdays": "Sábados",
        "sundays": "Domingos",
        "thursdays": "Jueves",
        "tuesdays": "Martes",
        "wednesdays": "Miércoles"
    },
    "tooltipText": {
        "enable_app_manage_priority": "Al habilitar esta aplicación podrás gestionar <b>Prioridad</b> en <b>Tareas</b> para este <b>proyecto</b>",
        "enable_app_manage_multiple_assignee": "Al habilitar esta aplicación podrás gestionar <b>Varios Asignados</b> en <b>Tareas</b> para este <b>proyecto</b>",
        "enable_app_manage_time_estimates": "Al habilitar esta aplicación podrás gestionar <b>Estimaciones de Tiempo</b> en <b>Tareas</b> para este <b>proyecto</b>",
        "enable_app_manage_tags": "Al habilitar esta aplicación podrás gestionar <b>Etiquetas</b> en <b>Tareas</b> para este <b>proyecto</b>",
        "enable_app_use_milestones": "Al habilitar esta aplicación podrás usar <b>Hitos</b> para este <b>proyecto</b>",
        "enable_app_use_ai_operations": "Al habilitar esta aplicación podrás usar <b>Operaciones de IA</b> para este <b>proyecto</b>",
        "enable_app_manage_time_log": "Al habilitar esta aplicación podrás gestionar <b>Registro de Tiempo</b> en <b>Tareas</b> para este <b>proyecto</b>",
        "enable_app_manage_custom_fields": "Al habilitar esta aplicación podrás gestionar <b>Campos Personalizados</b> para este <b>proyecto</b>"
    },
    "Company": {
        "fill_company_details": "Rellena los detalles de tu empresa",
        "set_up_company": "Configura tu Empresa",
        "creating_company": "Creando Empresa",
        "company_created": "Tu empresa ha sido creada. Hemos configurado los pasos iniciales. Por favor, espera un momento.",
        "good_to_go": "Listo para empezar",
        "select_default_country": "Selecciona el país predeterminado",
        "freelimitreachedstart": "Ya has creado una empresa gratuita. Para crear una nueva empresa, primero debes actualizar a un plan de pago",
        "freelimitreachedend": "Una vez actualizado, estarás listo para agregar otra empresa gratuita."
    },
    "Subscription": {
        "subscription_cancelled": "Has cancelado tu suscripción al final del período de suscripción actual",
        "discard_changes": "Un usuario en tu suscripción descartará estos cambios, y tu suscripción actual continuará desde el próximo ciclo de facturación.",
        "confirm_terminate_schedule": "¿Estás seguro de que deseas finalizar la cancelación programada de la suscripción?",
        "confirm_add_user": "¿Estás seguro de que deseas agregar un usuario a tu suscripción?",
        "confirm_remove_user": "¿Estás seguro de que deseas eliminar al usuario de la suscripción?",
        "next_invoice_amount": "Tu próxima factura será de",
        "credits_applied": "Créditos Aplicados",
        "current_billing_for_upgrade": "Facturación actual para la actualización",
        "plan_upgrade_success": "¡Felicidades! La actualización de tu plan ha sido programada con éxito y las mejoras entrarán en vigor después de que termine el término actual. Prepárate para experimentar las características y beneficios mejorados en la próxima fase de tu suscripción.",
        "subscription_upgrade_from": "Tu suscripción se actualizará desde",
        "total_payable_amount": "Monto Total a Pagar",
        "update_subscription": "Actualizar Suscripción",
        "updated_subscription_price": "Precio de Suscripción Actualizado",
        "upgrade_subscription": "Actualizar Suscripción",
        "confirm_subscription_change": "¿Estás seguro de que deseas cambiar tu suscripción de",
        "monthly": "Mes",
        "yearly": "Año",
        "remove_scheduled_cancellation_confirmation": "Al hacer clic en 'Sí' se eliminará la cancelación programada y tu ciclo de facturación continuará.",
        "scheduled_cancellation_notice": "Tienes una cancelación programada de tu suscripción actual para el",
        "credit_entitlement_congratulations": "¡Felicidades! Tienes derecho a un crédito de",
        "credit_note_application": "para tu suscripción actual. Este crédito se aplicará fácilmente para mejorar tu suscripción, y también se deducirá automáticamente de tus próximas facturas, garantizando valor y ahorros continuos para tu camino de suscripción.",
        "invoice_period_coverage": "La factura cubre el período desde"
    },
    "Card": {
        "pay_with": "Pagar con",
        "add_new_card": "Agregar Nueva Tarjeta",
        "name_on_card": "Nombre en la Tarjeta",
        "card_number": "Número de Tarjeta",
        "expiry": "Fecha de Expiración",
        "cvc": "CVC"
    },
    "alertBox": {
        "updateBillingAddress": "Necesitas actualizar la primera dirección de facturación",
        "valid_csv_title": "Archivo no subido",
        "valid_csv_text": "Por favor, sube un archivo .csv válido para continuar.",
        "ok": "OK",
        "cancel": "Cancelar",
        "go_back_title": "¿Volver atrás?",
        "go_back_text": "¿Estás seguro de que quieres volver al paso anterior?",
        "close_modal_title": "¿Cerrar ventana modal?",
        "close_modal_text": "¿Seguro que quieres cerrar la ventana modal? Toda la información ingresada hasta este paso se perderá.",
        "no": "No",
        "yes": "Sí",
        "confirm": "Confirmar",
        "improper_header_selection_title": "Selección no válida",
        "improper_header_selection_text": "La fila seleccionada contiene valores que no son cadenas de texto. Por favor, elige otra fila.",
        "missing_fields_title": "Faltan campos obligatorios",
        "missing_fields_text": "Debes asignar y confirmar los campos obligatorios antes de continuar.",
        "warning_title": "Advertencia",
        "warning_text": "Si continúas, los valores vacíos en 'Prioridad de la tarea' y 'Estado' se establecerán automáticamente en 'Media' y 'Pendiente', respectivamente.",
        "incomplete_mapping_title": "Asignación incompleta",
        "incomplete_mapping_text": "Por favor, asigna todos los valores únicos al menos a un valor en Hyphen OI Pro para continuar.",
        "invalid_tasks_error": "No se encontraron tareas válidas. Asegúrese de que los campos requeridos no estén vacíos."
    },
    "importTaskButton": {
        "import_title": "Importar tareas",
        "import_button": "Importar tareas desde CSV",
        "back_button": "Atrás",
        "next_button": "Siguiente",
        "export_button": "Exportar como CSV",
        "import_processing": "Tus tareas se están importando."
    },
    "importCsvAndSetHeader": {
        "download": "Descargar",
        "demo_csv": "CSV de muestra",
        "down_demo_text": "Compara este archivo con el que deseas importar para asegurarte de que es correcto.",
        "upload_button": "Sube tu archivo CSV aquí",
        "upload_instructions": "Puedes subir cualquier archivo .csv con cualquier conjunto de columnas, donde cada fila representa un registro. En el siguiente paso, podrás asignar las columnas de tu tabla a los datos correspondientes. Antes de la importación final, se pueden eliminar o corregir datos incorrectos.",
        "header_row_question": "¿La fila seleccionada contiene encabezados de columna?",
        "select_another_button": "Seleccionar otra fila",
        "confirm_row_btt": "Confirmar"
    },
    "headerMapping": {
        "title": "Asignar encabezados de columna",
        "mapping_instructions": "Vamos a asignar tus encabezados a los campos de Hyphen OI Pro",
        "pending_count": "Campos restantes:",
        "confirmed_count": "Campos confirmados:",
        "ignored_count": "Campos ignorados:",
        "custom_count": "Campos personalizados:",
        "confirmed_text": "Confirmado",
        "ignored_text": "Ignorado",
        "edit_button": "Editar",
        "no_match_title": "Sin coincidencia",
        "no_match": "No se encontraron coincidencias",
        "no_match_description": "Este campo no coincide con ningún encabezado de Hyphen OI Pro. Puedes ignorarlo o agregarlo como un campo personalizado.",
        "custom_field_button": "Agregar como campo personalizado",
        "ignore_field_button": "Ignorar este campo",
        "matched_to_field": "Asignado al campo:",
        "duplication_warning": "Este campo está duplicado y no se puede confirmar. Por favor, elige otro campo.",
        "confirm_map_button": "Confirmar asignación"
    },
    "reviewMaping": {
        "title": "Por favor, revisa los datos asignados a los campos. (También puedes editar los valores aquí).",
        "warning": "Uno o más campos obligatorios están ausentes o contienen valores no válidos. Por favor, revísalos, ya que de lo contrario estas filas no se importarán."
    },
    "valueMapping": {
        "user_mapping_title": "Asignación de usuarios",
        "user_mapping_instruction": "Asigna usuarios a los usuarios de Hyphen OI Pro para garantizar la correcta asignación de responsables de tareas, líderes y actividades. Si no asignas ningún usuario, estos datos no se importarán.",
        "user_dropdown_text": "Seleccionar usuario",
        "status_mapping_title": "Asignación de estado",
        "status_mapping_instruction": "Para garantizar un flujo de trabajo uniforme, asigna tus valores de estado a los valores existentes en Hyphen OI Pro. Esto ayudará a evitar errores en el futuro.",
        "status_dropdown_text": "Seleccionar estado",
        "priority_mapping_title": "Asignación de prioridad",
        "priority_mapping_instruction": "Para garantizar un flujo de trabajo uniforme, asigna tus valores de prioridad a los valores existentes en Hyphen OI Pro. Esto ayudará a evitar errores en el futuro.",
        "priority_dropdown_text": "Seleccionar prioridad",
        "custom_field_mapping_title": "Asignación de campos personalizados",
        "custom_field_mapping_instruction": "Para garantizar la compatibilidad, asigna los tipos de tus campos personalizados a los tipos existentes en Hyphen OI Pro. Esto ayudará a evitar errores en el futuro.",
        "custom_delimiters_quest": "ℹ️ ¿Tus campos personalizados contienen delimitadores?"
    },
    "importMappingKeywords": {
        "task_id_description": "El ID de la tarea en particular.",
        "task_name_description": "El nombre de la tarea, generalmente un breve resumen.",
        "task_description_description": "Información detallada sobre la tarea.",
        "task_assignee_description": "La dirección de correo electrónico de la persona asignada a la tarea.",
        "task_parentId_description": "El ID de la tarea principal a la que está asociada esta tarea.",
        "task_leaderId_description": "El ID de usuario de la persona que lidera esta tarea.",
        "task_priority_description": "El nivel de importancia asignado a la tarea.",
        "task_status_description": "El estado actual o el progreso de la tarea.",
        "task_start_date_description": "La fecha en que comienza la tarea.",
        "task_due_date_description": "La fecha en la que se debe completar la tarea."
    },
    "Affiliate": {
        "refer_earn": "Recomienda y gana",
        "unlimited": "Ilimitado",
        "invite_start_earning_cash_rewards": "Invita a tus amigos y empieza a ganar recompensas en efectivo.",
        "your_referral_code": "Tu código de referido",
        "invite_spend_message": "Por cada gasto de tu amigo, recibirás el {percentage}% de esa cantidad como recompensa.",
        "inviteText": "Invita a tus amigos compartiendo este enlace",
        "copy": "Copiar",
        "refferal_code_label": "Código de referencia",
        "refferal_code_placeholder": "Ingrese el código de referencia",
        "invalid_refferal_model_title": "Tu código de referencia no es válido",
        "invalid_refferal_model_confirm_text": "¡Sí, créalo!",
        "invalid_refferal_model_text": "¿Estás seguro de que quieres crear una empresa?",
        "refferal_code_error": "El código de referencia no es válido"
    },
    "dashboardCard": {
        "tasks_by_assignee_bar_chart_description": "Mostrar un gráfico de barras con el total de tareas por asignado",
        "tasks_by_assignee_bar_chart_title": "Tareas por asignado",
        "task_list_description": "Crear una vista de lista con tareas de cualquier ubicación",
        "tasks_list_title": "Lista de tareas",
        "tasks_by_assignee_stack_bar_chart_description": "Mostrar un gráfico de barras apiladas con el total de tareas por asignado",
        "tasks_by_assignee_stack_bar_chart_title": "Tareas por asignado",
        "workload_by_status_stack_bar_chart_description": "Mostrar un desglose de tus estados en diferentes ubicaciones",
        "workload_by_status_stack_bar_chart_title": "Carga de trabajo por estado",
        "tasks_by_assignee_pie_chart_description": "Mostrar un gráfico circular con el total de tareas por asignado",
        "tasks_by_assignee_pie_chart_title": "Tareas por asignado",
        "workload_by_status_pie_chart_description": "Mostrar un gráfico circular del uso de estados en diferentes ubicaciones",
        "workload_by_status_pie_chart_title": "Carga de trabajo por estado",
        "workload_by_status_bar_chart_description": "Mostrar un gráfico de barras del uso de estados en diferentes ubicaciones",
        "workload_by_status_bar_chart_title": "Carga de trabajo por estado",
        "queue_list_title": "Lista de cola",
        "queue_list_description": "Ver una lista de tus tareas junto con sus estados.",
        "card_name": "nombre de la tarjeta",
        "location": "proyecto",
        "group_by": "agrupar por",
        "show_assignees": "mostrar asignados",
        "include_subtasks": "incluir subtareas",
        "display_labels_as_percent": "mostrar etiquetas como porcentaje",
        "show_legend": "mostrar leyenda",
        "show_Data_Labels": "mostrar etiquetas de datos",
        "select": "seleccionar",
        "add_card": "Agregar tarjeta",
        "back": "Atrás",
        "error_assignees": "El campo de mostrar asignados es obligatorio",
        "error_location": "El campo de ubicación es obligatorio",
        "empty_layout_container": "Tu panel de control está vacío. Haz clic en 'Agregar tarjeta' para comenzar.",
        "status": "estado",
        "edit_card": "editar tarjeta",
        "calendar_card_title": "Calendario",
        "calendar_card_description": "Esta es la vista de calendario para tareas",
        "measure": "medida",
        "calculation": "cálculo",
        "total_urgent_tasks": "Total de tareas urgentes",
        "total_urgent_tasks_description": "Mostrar la cantidad total de tareas urgentes por ubicación",
        "time_tracker": "Rastreador de tiempo",
        "time_estimate": "Estimación de tiempo",
        "range": "Rango",
        "max": "Máx",
        "min": "Mín",
        "median": "Mediana",
        "average": "Promedio",
        "sum": "Suma",
        "workload_estination_title": "Informe de tiempo",
        "workload_estination_description": "Ver tareas con tiempo registrado y estimado.",
        "workload_only_estination_title": "Tiempo estimado",
        "workload_only_estination_description": "Ver el tiempo estimado.",
        "time_only_estination_title": "Tiempo registrado",
        "time_only_estination_description": "Ver el tiempo registrado.",
        "today": "Hoy",
        "yesterday": "Ayer",
        "this_week": "Esta semana",
        "last_week": "La semana pasada",
        "this_month": "Este mes",
        "last_month": "El mes pasado",
        "this_year": "Este año",
        "last_30_days": "Últimos 30 días",
        "task": "Conteo de tareas",
        "task_label": "Etiqueta de tarea",
        "both": "Mostrar ambos",
        "manual_time": "Mostrar solo el tiempo manual",
        "track_time": "Mostrar solo el tiempo rastreado",
        "logtype": "Registros de tiempo",
        "timerange": "Período de tiempo",
        "priority": "Prioridad",
        "due_date": "Fecha de vencimiento",
        "none": "Ninguno",
        "total_time_track_description": "Mostrar el tiempo total registrado",
        "total_time_track_tasks": "Tiempo total registrado",
        "total_tasks_count_description": "Mostrar el número total de tareas",
        "total_tasks_count": "Número total de tareas",
        "assignees": "Asignados a la tarea",
        "feature": "Funcionalidad",
        "workload": "Carga de trabajo",
        "time_tracking": "Seguimiento del tiempo",
        "task_card": "Tareas",
        "Today": "Hoy",
        "Yesterday": "Ayer",
        "Tomorrow": "Mañana",
        "This_week": "Esta semana",
        "Next_week": "La próxima semana",
        "Next_seven_days": "Los próximos 7 días",
        "Last_seven_days": "Los últimos 7 días",
        "Last_month": "El mes pasado",
        "This_month": "Este mes",
        "Next_month": "El próximo mes",
        "Date_range": "Rango de fechas",
        "me_mode": "yo",
        "data": "Datos",
        "display": "Mostrar",
        "fields": "Campos"
    },
    "designationMapping": {
        "title": "Mapeo de Designaciones",
        "description": "Por favor, asocie las designaciones en su CSV con las designaciones existentes en Hyphen OI Pro."
    },
    "roleMapping": {
        "title": "Mapeo de Roles",
        "description": "Por favor, asocie los roles en su CSV con los roles existentes en Hyphen OI Pro."
    },
    "importUserKeywords": {
        "user_email_description": "Correo electrónico del usuario",
        "user_role_description": "El rol o título de trabajo asignado al usuario dentro de la organización.",
        "user_designation_description": "La designación oficial o título del puesto del empleado dentro de la empresa."
    },
    "userSelection": {
        "title": "Selección de Usuarios",
        "user_limit_error": "Se ha alcanzado el límite máximo de usuarios. Por favor, actualice su plan para importar más usuarios.",
        "description": "Seleccione todos los usuarios que desea importar.",
        "duplicate_email_error": "Este correo electrónico ya existe en Hyphen OI Pro. No puede importarlo.",
        "invalid_email": "Este correo electrónico no es válido. Por favor, use un correo válido.",
        "invalid_fields": "Tienes uno o más campos no válidos. Por favor, revisa los campos resaltados.",
        "user_limit_100": "Puedes importar un máximo de 100 usuarios a la vez."
    },
    "importUserButton": {
        "import_user_processing": "Tus usuarios están siendo importados"
    },
    "timeForecastingReport": {
        "project_name": "Nombre del proyecto",
        "project_status": "Estado del proyecto",
        "start_date": "Fecha de inicio",
        "due_date": "Fecha de vencimiento",
        "last_logged_date": "Última fecha registrada",
        "budget": "Presupuesto",
        "actual": "Real",
        "forecast": "Pronóstico",
        "estimated_hours": "Horas estimadas",
        "logged_hours": "Horas registradas",
        "remaining_hours": "Horas restantes",
        "overdue_hours": "Horas vencidas",
        "estimated_time_to_complete": "Tiempo estimado para completar",
        "estimated_complition_date": "Fecha estimada de finalización",
        "show_legends": "Mostrar leyendas",
        "show_data_labels": "Mostrar etiquetas de datos",
        "report_type": "Tipo de informe"
    }
}